import React, { useState } from 'react';

import apiCall, { LIVE_URL } from '~/utils/apiCall';
import isEmpty from '~/utils/valid/is-empty';

import DabangBi from './images/dabang-bi.png';
import CompleteGif from './images/join.gif';

import {
  Wrap, QuestionWrap,
  NoticeWrap, Notice, Terms,
  ProgressBar,
  InputWrap, Label, Input,
  RadioRow, RadioLabel, Radio,
  Textarea,
  CheckLabel, Check, TextContent,
  BtnWrap, BlueButton, GrayButton,
  CompleteImg,
} from './styled';

const INIT_USER_INFO = {
  companyName: '',
  departmentName: '',
  email: '',
  gender: null,
  method: '',
  phone: '',
  positionName: null,
  seq: null,
  surveyFinish: false,
  userName: '',
  year: null,

  infoQuestion1: '',
  infoQuestion2: '',
  infoQuestion2Etc: '',
  infoQuestion3: '',
  infoQuestion3Etc: '',
}

const INIT_TASK = {
  task1Question1: '',
  task1Question2: '',
  task1Question3: '',
  
  task2Question1: '',
  task2Question2: '',
  task2Question3: '',

  task3Question1: '',
  task3Question2: '',
  task3Question3: '',

  task4Question1: '',
  task4Question2: '',
  task4Question3: '',
  task4Question3Etc: '',
  task4Question4: '',
  task4Question4Etc: '',

  task5Question1: '',
  task5Question2: '',
  task5Question2Etc: '',
  task5Question3: '',
  task5Question3Etc: '',
  task5Question4: '',
  task5Question4Etc: '',
  task5Question5: '',
  task5Question5Etc: '',
  task5Question6: '',
  task5Question7: '',
  task5Question8: '',

  task6Question1: '',
  task6Question1Etc: '',
  task6Question2: '',
  task6Question3: '',
  task6Question4: '',
  task6Question5: '',
  task6Question6: '',
  task6Question7: '',
  task6Question7Etc: '',

  task7Question1: '',
  task7Question2: '',
  task7Question3: '',
  task7Question4: '',
  
  taskResultQuestion: '',

  useQuestion1: '',
  useQuestion2: '',
  useQuestion3: '',
  useQuestion3Etc: '',
  useQuestion4: '',
  useQuestion4Etc: '',
  useQuestion4Reason: '',
  useQuestion5: '',
  useQuestion5Reason: '',
  useQuestion6: '',
  useQuestion6Etc: '',
  useQuestion6Reason: '',
  useQuestion7: '',
  useQuestion7Reason: '',
  useQuestion8: '',
  useQuestion8Reason: '',
  useQuestion9: '',
  useQuestion10: '',
  useQuestion10Etc: '',
  useQuestion10Reason: '',
  useQuestion11: '',
  useQuestion11Etc: '',
  useQuestion11Reason: '',

  diffQuestion1: '',
  diffQuestion2: '',
  diffQuestion2Reason: '',
  diffQuestion3: '',
  diffQuestion3Reason: '',
  diffQuestion4: '',
  diffQuestion4Reason: '',
  diffQuestion5: '',
  diffQuestion5Reason: '',
  diffQuestion6: '',
  diffQuestion6Reason: '',
  diffQuestion7: '',
  diffQuestion7Reason: '',
  diffQuestion8: '',
  diffQuestion8Reason: '',
  diffQuestion9: '',
  diffQuestion9Reason: '',
  diffQuestion10: '',
  diffQuestion10Reason: '',
  diffQuestion11: '',
  diffQuestion11Reason: '',
}

function DabangSurvey() {
  const [agree, setAgree] = useState(false);
  const [step, setStep] = useState('findUser');
  const [userInfo, setUserInfo] = useState(INIT_USER_INFO);
  const [task, setTask] = useState(INIT_TASK);
  const [id, setId] = useState('');
  const [sending, setSending] = useState(false);

  function changeUserInfo(e) {
    const { name, value } = e.currentTarget;

    setUserInfo(prev => ({
      ...prev,
      [name]: value,
    }));
  }

  async function getUserInfo() {
    if (isEmpty(id)) return alert('이메일 또는 연락처를 입력해주세요.');
    if (sending) return;

    setSending(true);

    try {
      const res = await apiCall.post(`${LIVE_URL}/api/v1/event/app-survey/dabang/target`, { value: id });
      const { code, result } = res;

      setSending(false);

      if (code === 200) {
        setUserInfo(prev => ({
          ...prev,
          ...result,
        }));
        setStep('checkUser');

      } else {
        alert(res?.msg ?? '서버에러가 발생했습니다.');
      }

    } catch(err) {
      console.log(err);
      setSending(false);
    }
  }

  function clickGoSetUser() {
    if (!window.confirm(`
    설문전 필수 확인사항!
    1. 보유중인 휴대폰에 다방앱을 실행해주세요.
    2. 기존에 이미 다방 회원이신 경우 탈퇴 후 진행해주세요.
    3. 매 Task 진행시 로그아웃 후 홈화면에서 진행해주세요.
    4. 매 Task 진행시 다방앱을 재실행한 후 홈화면에서 진행해주세요.`)) return;

    setStep('setUser');
  }

  function changeStep(nextStep) {
    const isPrev = nextStep - step < 0;

    if (isPrev) return setStep(nextStep);

    if (nextStep === 1) {
      const valid = [userInfo.infoQuestion1, userInfo.infoQuestion2, userInfo.infoQuestion3].every(val => !isEmpty(val));

      if (userInfo.infoQuestion2.includes('기타') && isEmpty(userInfo.infoQuestion2Etc)) return alert("기타 의견을 입력해 주세요.");
      if (userInfo.infoQuestion3.includes('기타') && isEmpty(userInfo.infoQuestion3Etc)) return alert("기타 의견을 입력해 주세요.");
      if (!valid) return alert("필수 항목을 입력해 주세요.");

    } else if (nextStep === 2) {
      const valid = [task.task1Question1, task.task1Question2, task.task1Question3].every(val => !isEmpty(val));

      if (!valid) return alert("필수 항목을 입력해 주세요.");

    } else if (nextStep === 3) {
      const valid = [task.task2Question1, task.task2Question2, task.task2Question3].every(val => !isEmpty(val));

      if (!valid) return alert("필수 항목을 입력해 주세요.");

    } else if (nextStep === 4) {
      const valid = [task.task3Question1, task.task3Question2, task.task3Question3].every(val => !isEmpty(val));

      if (!valid) return alert("필수 항목을 입력해 주세요.");

    } else if (nextStep === 5) {
      const valid = [task.task4Question1, task.task4Question2, task.task4Question3, task.task4Question4].every(val => !isEmpty(val));

      if (task.task4Question3.includes('기타') && isEmpty(task.task4Question3Etc)) return alert("기타 의견을 입력해 주세요.");
      if (task.task4Question4.includes('기타') && isEmpty(task.task4Question4Etc)) return alert("기타 의견을 입력해 주세요.");
      if (!valid) return alert("필수 항목을 입력해 주세요.");

    } else if (nextStep === 6) {
      const valid = [task.task5Question1, task.task5Question2, task.task5Question3, task.task5Question4, task.task5Question5, task.task5Question6, task.task5Question7, task.task5Question8].every(val => !isEmpty(val));

      if (task.task5Question2.includes('기타') && isEmpty(task.task5Question2Etc)) return alert("기타 의견을 입력해 주세요.");
      if (task.task5Question3.includes('기타') && isEmpty(task.task5Question3Etc)) return alert("기타 의견을 입력해 주세요.");
      if (task.task5Question4.includes('기타') && isEmpty(task.task5Question4Etc)) return alert("기타 의견을 입력해 주세요.");
      if (task.task5Question5.includes('기타') && isEmpty(task.task5Question5Etc)) return alert("기타 의견을 입력해 주세요.");
      if (!valid) return alert("필수 항목을 입력해 주세요.");

    } else if (nextStep === 7) {
      const valid = [task.task6Question1, task.task6Question2, task.task6Question3, task.task6Question4, task.task6Question5, task.task6Question6, task.task6Question7].every(val => !isEmpty(val));

      if (task.task6Question1.includes('기타') && isEmpty(task.task6Question1Etc)) return alert("기타 의견을 입력해 주세요.");
      if (task.task6Question7.includes('기타') && isEmpty(task.task6Question7Etc)) return alert("기타 의견을 입력해 주세요.");
      if (!valid) return alert("필수 항목을 입력해 주세요.");

    } else if (nextStep === 8) {
      const valid = [task.task7Question1, task.task7Question2, task.task7Question3, task.task7Question4].every(val => !isEmpty(val));
      if (!valid) return alert("필수 항목을 입력해 주세요.");

    } else if (nextStep === 9) {
      const valid = [task.taskResultQuestion].every(val => !isEmpty(val));
      if (!valid) return alert("필수 항목을 입력해 주세요.");

    } else if (nextStep === 10) {
      if (task.useQuestion1 === '네') {
        const valid = [task.useQuestion2, task.useQuestion3, task.useQuestion4, task.useQuestion4Reason, task.useQuestion5, task.useQuestion5Reason, task.useQuestion6, task.useQuestion6Reason, task.useQuestion7, task.useQuestion7Reason, task.useQuestion8, task.useQuestion8Reason, task.useQuestion9, task.useQuestion10, task.useQuestion10Reason, task.useQuestion11, task.useQuestion11Reason].every(val => !isEmpty(val));
        if (task.useQuestion3.includes('기타') && isEmpty(task.useQuestion3Etc)) return alert("기타 의견을 입력해 주세요.");
        if (task.useQuestion4.includes('기타') && isEmpty(task.useQuestion4Etc)) return alert("기타 의견을 입력해 주세요.");
        if (task.useQuestion6.includes('기타') && isEmpty(task.useQuestion6Etc)) return alert("기타 의견을 입력해 주세요.");
        if (task.useQuestion10.includes('기타') && isEmpty(task.useQuestion10Etc)) return alert("기타 의견을 입력해 주세요.");
        if (task.useQuestion11.includes('기타') && isEmpty(task.useQuestion11Etc)) return alert("기타 의견을 입력해 주세요.");

        if (!valid) return alert("필수 항목을 입력해 주세요.");
      }
    }

    setStep(nextStep);
  }

  function changeTaskInput(e) {
    const { name, value } = e.currentTarget;

    setTask(prev => ({
      ...prev,
      [name]: value,
    }));
  }

  function changeTaskCheck(e) {
    const { name, value } = e.currentTarget;

    const isEtc = value === '기타';
    const tempTaskArr = [...task[name]];
    const idx = tempTaskArr.indexOf(value);
    const checked = idx !== -1;
    const etcValue = isEtc && checked ? '' : task[`${name}Etc`];

    if (checked) {
      tempTaskArr.splice(idx, 1);

    } else {
      tempTaskArr.push(value);
    }

    setTask(prev => {
      if (task.hasOwnProperty(`${name}Etc`)) {
        return {
          ...prev,
          [name]: tempTaskArr,
          [`${name}Etc`]: etcValue,
        }
      }

      return {
        ...prev,
        [name]: tempTaskArr,
      }
    });
  }

  function clickAddSurvey(e) {
    const { name, value } = e.currentTarget;

    if (value === '아니오') {
      if (!window.confirm('타사 서비스 대비 사용성 평가로 이동합니다.')) {
        return setTask(prev => ({
          ...prev,
          [name]: '',
        }));
      }

      changeTaskInput(e);
      setStep(10);
    }
  }

  async function submit() {
    if (sending) return;

    if (!window.confirm('설문을 제출 하시겠습니까?')) return;

    setSending(true);

    try {
      let tempTask = {};

      // info 
      tempTask["infoQuestion1"] = userInfo.infoQuestion1;
      tempTask["infoQuestion2"] = userInfo.infoQuestion2;
      tempTask["infoQuestion3"] = userInfo.infoQuestion3;

      for (let [key, value] of Object.entries(task)) {
        const isArr = Array.isArray(value);

        if (isArr) {
          const idx = value.findIndex(v => v === '기타');
      
          if (idx !== -1) {
            value[idx] = `기타_${task[`${key}Etc`]}`
          }
      
        } else {
          if (value === '기타') {
            value = `기타_${task[`${key}Etc`]}`
          }
        }
      
        tempTask[key] = isEmpty(value) ? null : value;
      }

      const res = await apiCall.post(`${LIVE_URL}/api/v1/event/app-survey/dabang/submit`, {
        targetSeq: userInfo.seq,
        ...tempTask,
      });

      const { code } = res;

      if (code === 200) {
        setStep('complete');

      } else {
        alert(res?.msg ?? '서버에러가 발생했습니다.');
      }

      setSending(false);

    } catch(err) {
      console.log(err);
      setSending(false);
    }
  }

  return (
    <Wrap>
      <div>
        <img src={DabangBi} alt="다방로고" style={{ marginBottom: 32 }} />

        {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].includes(step) && (
          <ProgressBar step={step} />
        )}

        {[1, 2, 3, 4, 5, 6, 7].includes(step) && (
          <NoticeWrap>
            <Notice>설문전 필수 확인사항!</Notice>
            <Notice>1. 보유중인 휴대폰에 다방앱을 설치 및 실행해주세요.</Notice>
            <Notice>2. 기존에 이미 다방 회원이신 경우 탈퇴 후 진행해주세요.</Notice>
            <Notice>3. 매 Task 진행시 로그아웃 후 홈화면에서 진행해주세요.</Notice>
            <Notice>4. 매 Task 진행시 다방앱을 재실행한 후 홈화면에서 진행해주세요.</Notice>
          </NoticeWrap>
        )}
  
        {step === 'findUser' ? (
          <>
            <h1 style={{ lineHeight: '32px', marginBottom: 32 }}>다방 사용성 평가 설문조사</h1>

            <QuestionWrap>
              <InputWrap>
                <Label>
                  <p>이메일 또는 연락처를 입력해 주세요. <span style={{ color: 'red' }}>연락처 입력 시 - 제외해 주세요.</span></p>
  
                  <Input
                    name="id"
                    value={id}
                    placeholder="이메일 또는 연락처를 입력해주세요."
                    onChange={e => setId(e.currentTarget.value)}
                  />
                </Label>
              </InputWrap>
  
              <BtnWrap style={{ marginTop: 12 }}>
                <BlueButton
                  style={{ width: '100%' }}
                  onClick={() => getUserInfo()}
                >
                  확인
                </BlueButton>
              </BtnWrap>
            </QuestionWrap>
          </>
        ) : step === 'checkUser' ? (
          <>
            <h1 style={{ lineHeight: '32px', marginBottom: 32 }}>평가자 정보 확인</h1>

            <InputWrap>
              <Label>
                <p>소속 / 팀</p>

                <Input
                  value={`${userInfo.companyName}${userInfo?.departmentName ? ` / ${userInfo.departmentName}` : ''}`}
                  readOnly
                />
              </Label>
            </InputWrap>

            <InputWrap>
              <Label>
                <p>이름</p>

                <Input
                  value={userInfo.userName}
                  readOnly
                />
              </Label>
            </InputWrap>

            <InputWrap>
              <Label>
                <p>이메일</p>

                <Input
                  value={userInfo.email}
                  readOnly
                />
              </Label>
            </InputWrap>

            <InputWrap>
              <Label>
                <p>연락처</p>

                <Input
                  value={userInfo.phone}
                  readOnly
                />
              </Label>
            </InputWrap>

            <Notice style={{ margin: '20px 0' }}>위 정보가 맞는지 확인후 설문을 시작해주세요!</Notice>

            <CheckLabel>
              <Check
                type="checkbox"
                name="agree"
                checked={agree}
                onChange={e => setAgree(e.currentTarget.checked)}
              />
              <TextContent>개인정보 수집 및 이용 동의</TextContent>
            </CheckLabel>

            <BtnWrap style={{ marginTop: 32, width: '100%' }}>
              <BlueButton
                disabled={!agree}
                style={{ width: '100%' }}
                onClick={() => clickGoSetUser()}
              >
                설문 시작히기!
              </BlueButton>
            </BtnWrap>
          </>
        ) : step === 'setUser' ? (
          <>
            <h1 style={{ lineHeight: '32px', marginBottom: 32 }}>사용성 평가 참여자 정보 입력</h1>

            <QuestionWrap>
              <InputWrap>
                <Label>
                  <p>Q. 거주지역을 입력해 주세요.<span>*</span></p>
                  <Input
                    name="infoQuestion1"
                    value={userInfo.infoQuestion1}
                    onChange={changeUserInfo}
                    placeholder="서울특별시 서초구 서초동"
                  />
                </Label>
              </InputWrap>
            </QuestionWrap>
    
            <QuestionWrap>
              <p>Q. 거주유형을 입력해주세요.<span>*</span></p>
              <RadioRow>
                <RadioLabel>
                  <Radio
                    type="radio" 
                    name="infoQuestion2"
                    value="자가"
                    checked={userInfo.infoQuestion2 === '자가'}
                    onChange={changeUserInfo}
                  />
                  자가
                </RadioLabel>
              </RadioRow>

              <RadioRow>
                <RadioLabel>
                  <Radio
                    type="radio" 
                    name="infoQuestion2"
                    value="전세"
                    checked={userInfo.infoQuestion2 === '전세'}
                    onChange={changeUserInfo}
                  />
                  전세
                </RadioLabel>
              </RadioRow>

              <RadioRow>
                <RadioLabel>
                  <Radio
                    type="radio" 
                    name="infoQuestion2"
                    value="월세"
                    checked={userInfo.infoQuestion2 === '월세'}
                    onChange={changeUserInfo}
                  />
                  월세
                </RadioLabel>
              </RadioRow>

              <RadioRow>
                <RadioLabel>
                  <Radio
                    type="radio" 
                    name="infoQuestion2"
                    value="기타"
                    checked={userInfo.infoQuestion2 === '기타'}
                    onChange={changeUserInfo}
                  />
                  기타
                </RadioLabel>
              </RadioRow>

              {userInfo.infoQuestion2.includes('기타') && (
                <InputWrap>
                  <Label>
                    <p>기타의견을 작성해 주세요.</p>
                    <Input
                      name="infoQuestion2Etc"
                      value={userInfo.infoQuestion2Etc}
                      onChange={changeUserInfo}
                    />
                  </Label>
                </InputWrap>
              )}
            </QuestionWrap>

            <QuestionWrap>
              <p>Q. 테스트를 진행하는 개인 핸드폰 기종을 선택해 주세요.<span>*</span></p>
              <RadioRow>
                <RadioLabel>
                  <Radio
                    type="radio" 
                    name="infoQuestion3"
                    value="iOS"
                    checked={userInfo.infoQuestion3 === 'iOS'}
                    onChange={changeUserInfo}
                  />
                  iOS
                </RadioLabel>
              </RadioRow>
        
              <RadioRow>
                <RadioLabel>
                  <Radio
                    type="radio" 
                    name="infoQuestion3"
                    value="AOS"
                    checked={userInfo.infoQuestion3 === 'AOS'}
                    onChange={changeUserInfo}
                  />
                  AOS
                </RadioLabel>
              </RadioRow>
    
              <RadioRow>
                <RadioLabel>
                  <Radio
                    type="radio" 
                    name="infoQuestion3"
                    value="기타"
                    checked={userInfo.infoQuestion3 === '기타'}
                    onChange={changeUserInfo}
                  />
                  기타
                </RadioLabel>
              </RadioRow>

              {userInfo.infoQuestion3.includes('기타') && (
                <InputWrap>
                  <Label>
                    <p>기타의견을 작성해 주세요.</p>
                    <Input
                      name="infoQuestion3Etc"
                      value={userInfo.infoQuestion3Etc}
                      onChange={changeUserInfo}
                    />
                  </Label>
                </InputWrap>
              )}
            </QuestionWrap>
  
            <BtnWrap>
              <BlueButton
                style={{ width: 120 }}
                onClick={() => changeStep(1)}
              >
                다음
              </BlueButton>
            </BtnWrap>
          </>
        ) : step === 1 ? (
          <>
            <h1 style={{ lineHeight: '32px' }}>TASK1. 다방앱을 실행하여 (신림동) 기준 원룸, 월세 50만원~100만원</h1>
            <h1 style={{ lineHeight: '32px', marginBottom: 32 }}>매물을 검색해보세요. (홈화면에서 시작해주세요.)</h1>
  
            <QuestionWrap>
              <p>Q. 수행과정을 상세하게 작성해주세요.<span>*</span></p>
              <p>(어떤 메뉴로 진입 및 클릭했는지 최대한 자세하게)</p>

              <Textarea
                name="task1Question1"
                value={task.task1Question1}
                onChange={changeTaskInput}
              />
            </QuestionWrap>
  
            <QuestionWrap>
              <p>Q. 수행 과정이 쉬웠습니까?<span>*</span></p>

              <RadioRow>
                <RadioLabel>
                  <Radio
                    type="radio"
                    name="task1Question2"
                    value="어렵다"
                    checked={task.task1Question2 === '어렵다'}
                    onChange={changeTaskInput}
                  />
                  어렵다
                </RadioLabel>
              </RadioRow>
        
              <RadioRow>
                <RadioLabel>
                  <Radio
                    type="radio"
                    name="task1Question2"
                    value="보통이다"
                    checked={task.task1Question2 === '보통이다'}
                    onChange={changeTaskInput}
                  />
                  보통이다
                </RadioLabel>
              </RadioRow>
    
              <RadioRow>
                <RadioLabel>
                  <Radio
                    type="radio"
                    name="task1Question2"
                    value="쉽다"
                    checked={task.task1Question2 === '쉽다'}
                    onChange={changeTaskInput}
                  />
                  쉽다
                </RadioLabel>
              </RadioRow>
            </QuestionWrap>
  
            <QuestionWrap>
              <p>Q. 수행과정이 보통이거나 어려웠다면 왜 그렇게 생각하십니까?<span>*</span></p>

              <Textarea
                name="task1Question3"
                value={task.task1Question3}
                onChange={changeTaskInput}
              />
            </QuestionWrap>
  
            <BtnWrap>
              <GrayButton
                style={{ width: 120 }}
                onClick={() => changeStep('setUser')}
              >
                이전
              </GrayButton>
    
              <BlueButton
                style={{ width: 120 }}
                onClick={() => changeStep(2)}
              >
                다음
              </BlueButton>
            </BtnWrap>
          </>
        ) : step === 2 ? (
          <>
            <h1 style={{ lineHeight: '32px' }}>TASK2. 다방앱을 실행하여 (서울대입구역) 기준 투쓰리룸/오피스텔</h1>
            <h1 style={{ lineHeight: '32px', marginBottom: 32 }}>방크기(전용면적) 33m²(10평) 이하의 매물을 검색해보세요. (홈화면에서 시작해주세요.)</h1>

            <QuestionWrap>
              <p>Q. 수행과정을 상세하게 작성해주세요.<span>*</span></p>
              <p>(어떤 메뉴로 진입 및 클릭했는지 최대한 자세하게)</p>

              <Textarea
                name="task2Question1"
                value={task.task2Question1}
                onChange={changeTaskInput}
              />
            </QuestionWrap>
  
            <QuestionWrap>
              <p>Q. 수행 과정이 쉬웠습니까?<span>*</span></p>

              <RadioRow>
                <RadioLabel>
                  <Radio
                    type="radio"
                    name="task2Question2"
                    value="어렵다"
                    checked={task.task2Question2 === '어렵다'}
                    onChange={changeTaskInput}
                  />
                  어렵다
                </RadioLabel>
              </RadioRow>
        
              <RadioRow>
                <RadioLabel>
                  <Radio
                    type="radio"
                    name="task2Question2"
                    value="보통이다"
                    checked={task.task2Question2 === '보통이다'}
                    onChange={changeTaskInput}
                  />
                  보통이다
                </RadioLabel>
              </RadioRow>
    
              <RadioRow>
                <RadioLabel>
                  <Radio
                    type="radio"
                    name="task2Question2"
                    value="쉽다"
                    checked={task.task2Question2 === '쉽다'}
                    onChange={changeTaskInput}
                  />
                  쉽다
                </RadioLabel>
              </RadioRow>
            </QuestionWrap>
  
            <QuestionWrap>
              <p>Q. 수행과정이 보통이거나 어려웠다면 왜 그렇게 생각하십니까?<span>*</span></p>

              <Textarea
                name="task2Question3"
                value={task.task2Question3}
                onChange={changeTaskInput}
              />
            </QuestionWrap>
  
            <BtnWrap>
              <GrayButton
                style={{ width: 120 }}
                onClick={() => changeStep(1)}
              >
                이전
              </GrayButton>
    
              <BlueButton
                style={{ width: 120 }}
                onClick={() => changeStep(3)}
              >
                다음
              </BlueButton>
            </BtnWrap>
          </>
        ) : step === 3 ? (
          <>
            <h1 style={{ lineHeight: '32px' }}>TASK3. 다방앱을 실행하여 (서울대학교) 기준 투룸</h1>
            <h1 style={{ lineHeight: '32px', marginBottom: 32 }}>전세 5억이하 주차가능한 매물을 검색해보세요. (홈화면에서 시작해주세요.)</h1>

            <QuestionWrap>
              <p>Q. 수행과정을 상세하게 작성해주세요.<span>*</span></p>
              <p>(어떤 메뉴로 진입 및 클릭했는지 최대한 자세하게)</p>

              <Textarea
                name="task3Question1"
                value={task.task3Question1}
                onChange={changeTaskInput}
              />
            </QuestionWrap>
  
            <QuestionWrap>
              <p>Q. 수행 과정이 쉬웠습니까?<span>*</span></p>

              <RadioRow>
                <RadioLabel>
                  <Radio
                    type="radio"
                    name="task3Question2"
                    value="어렵다"
                    checked={task.task3Question2 === '어렵다'}
                    onChange={changeTaskInput}
                  />
                  어렵다
                </RadioLabel>
              </RadioRow>
        
              <RadioRow>
                <RadioLabel>
                  <Radio
                    type="radio"
                    name="task3Question2"
                    value="보통이다"
                    checked={task.task3Question2 === '보통이다'}
                    onChange={changeTaskInput}
                  />
                  보통이다
                </RadioLabel>
              </RadioRow>
    
              <RadioRow>
                <RadioLabel>
                  <Radio
                    type="radio"
                    name="task3Question2"
                    value="쉽다"
                    checked={task.task3Question2 === '쉽다'}
                    onChange={changeTaskInput}
                  />
                  쉽다
                </RadioLabel>
              </RadioRow>
            </QuestionWrap>
  
            <QuestionWrap>
              <p>Q. 수행과정이 보통이거나 어려웠다면 왜 그렇게 생각하십니까?<span>*</span></p>

              <Textarea
                name="task3Question3"
                value={task.task3Question3}
                onChange={changeTaskInput}
              />
            </QuestionWrap>

            <BtnWrap>
              <GrayButton
                style={{ width: 120 }}
                onClick={() => changeStep(2)}
              >
                이전
              </GrayButton>
    
              <BlueButton
                style={{ width: 120 }}
                onClick={() => changeStep(4)}
              >
                다음
              </BlueButton>
            </BtnWrap>
          </>
        ) : step === 4 ? (
          <>
            <h1 style={{ lineHeight: '32px', marginBottom: 32 }}>TASK4. 다방앱을 실행하여 (신림동) 검색한 후 매물리스트를 확인해 주세요. (홈화면에서 시작해주세요.)</h1>

            <QuestionWrap>
              <p>Q. 수행과정을 상세하게 작성해주세요.<span>*</span></p>
              <p>(어떤 메뉴로 진입 및 클릭했는지 최대한 자세하게)</p>

              <Textarea
                name="task4Question1"
                value={task.task4Question1}
                onChange={changeTaskInput}
              />
            </QuestionWrap>

            <QuestionWrap>
              <p>Q. 매물 리스트내에서 제공하는 매물의 종류 중 선호하는 또는 관심있는 매물의 형태는 무엇인가요?.<span>*</span></p>
              <p style={{ color: 'red', textDecoration: 'underline' }}>[다중선택 가능]</p>

              <RadioRow style={{ marginTop: 8 }}>
                <CheckLabel>
                  <Check
                    type="checkbox"
                    name="task4Question2"
                    value="프리미엄매물"
                    checked={task.task4Question2.includes('프리미엄매물')}
                    onChange={changeTaskCheck}
                  />
                  <TextContent>프리미엄매물</TextContent>
                </CheckLabel>

                <CheckLabel>
                  <Check
                    type="checkbox"
                    name="task4Question2"
                    value="다방싸인매물"
                    checked={task.task4Question2.includes('다방싸인매물')}
                    onChange={changeTaskCheck}
                  />
                  <TextContent>다방싸인매물</TextContent>
                </CheckLabel>

                <CheckLabel>
                  <Check
                    type="checkbox"
                    name="task4Question2"
                    value="플러스매물"
                    checked={task.task4Question2.includes('플러스매물')}
                    onChange={changeTaskCheck}
                  />
                  <TextContent>플러스매물</TextContent>
                </CheckLabel>
              </RadioRow>

              <RadioRow>
                <CheckLabel>
                  <Check
                    type="checkbox"
                    name="task4Question2"
                    value="간편문의 가능 매물"
                    checked={task.task4Question2.includes('간편문의 가능 매물')}
                    onChange={changeTaskCheck}
                  />
                  <TextContent>간편문의 가능 매물</TextContent>
                </CheckLabel>

                <CheckLabel>
                  <Check
                    type="checkbox"
                    name="task4Question2"
                    value="상관없다"
                    checked={task.task4Question2.includes('상관없다')}
                    onChange={changeTaskCheck}
                  />
                  <TextContent>상관없다</TextContent>
                </CheckLabel>

                <CheckLabel>
                  <Check
                    type="checkbox"
                    name="task4Question2"
                    value="잘모르겠다"
                    checked={task.task4Question2.includes('잘모르겠다')}
                    onChange={changeTaskCheck}
                  />
                  <TextContent>잘모르겠다</TextContent>
                </CheckLabel>
              </RadioRow>
            </QuestionWrap>

            <QuestionWrap>
              <p>Q. 매물 리스트내에서 제공하는 매물의 정보 중 가장 필요하다고 생각하는 항목은 무엇인가요?<span>*</span></p>
              <p style={{ color: 'red', textDecoration: 'underline' }}>[다중선택 가능]</p>

              <RadioRow style={{ marginTop: 8 }}>
                <CheckLabel>
                  <Check
                    type="checkbox"
                    name="task4Question3"
                    value="사진"
                    checked={task.task4Question3.includes('사진')}
                    onChange={changeTaskCheck}
                  />
                  <TextContent>사진</TextContent>
                </CheckLabel>

                <CheckLabel>
                  <Check
                    type="checkbox"
                    name="task4Question3"
                    value="금액"
                    checked={task.task4Question3.includes('금액')}
                    onChange={changeTaskCheck}
                  />
                  <TextContent>금액</TextContent>
                </CheckLabel>

                <CheckLabel>
                  <Check
                    type="checkbox"
                    name="task4Question3"
                    value="층수"
                    checked={task.task4Question3.includes('층수')}
                    onChange={changeTaskCheck}
                  />
                  <TextContent>층수</TextContent>
                </CheckLabel>
              </RadioRow>

              <RadioRow>
                <CheckLabel>
                  <Check
                    type="checkbox"
                    name="task4Question3"
                    value="면적"
                    checked={task.task4Question3.includes('면적')}
                    onChange={changeTaskCheck}
                  />
                  <TextContent>면적</TextContent>
                </CheckLabel>

                <CheckLabel>
                  <Check
                    type="checkbox"
                    name="task4Question3"
                    value="관리비"
                    checked={task.task4Question3.includes('관리비')}
                    onChange={changeTaskCheck}
                  />
                  <TextContent>관리비</TextContent>
                </CheckLabel>

                <CheckLabel>
                  <Check
                    type="checkbox"
                    name="task4Question3"
                    value="주차여부"
                    checked={task.task4Question3.includes('주차여부')}
                    onChange={changeTaskCheck}
                  />
                  <TextContent>주차여부</TextContent>
                </CheckLabel>
              </RadioRow>

              <RadioRow>
                <CheckLabel>
                  <Check
                    type="checkbox"
                    name="task4Question3"
                    value="단기임대여부"
                    checked={task.task4Question3.includes('단기임대여부')}
                    onChange={changeTaskCheck}
                  />
                  <TextContent>단기임대여부</TextContent>
                </CheckLabel>

                <CheckLabel>
                  <Check
                    type="checkbox"
                    name="task4Question3"
                    value="입주가능일"
                    checked={task.task4Question3.includes('입주가능일')}
                    onChange={changeTaskCheck}
                  />
                  <TextContent>입주가능일</TextContent>
                </CheckLabel>

                <CheckLabel>
                  <Check
                    type="checkbox"
                    name="task4Question3"
                    value="매물설명"
                    checked={task.task4Question3.includes('매물설명')}
                    onChange={changeTaskCheck}
                  />
                  <TextContent>매물설명</TextContent>
                </CheckLabel>
              </RadioRow>

              <RadioRow>
                <CheckLabel>
                  <Check
                    type="checkbox"
                    name="task4Question3"
                    value="방수"
                    checked={task.task4Question3.includes('방수')}
                    onChange={changeTaskCheck}
                  />
                  <TextContent>방수</TextContent>
                </CheckLabel>

                <CheckLabel>
                  <Check
                    type="checkbox"
                    name="task4Question3"
                    value="욕실수"
                    checked={task.task4Question3.includes('욕실수')}
                    onChange={changeTaskCheck}
                  />
                  <TextContent>욕실수</TextContent>
                </CheckLabel>

                <CheckLabel>
                  <Check
                    type="checkbox"
                    name="task4Question3"
                    value="매물위치(주소)"
                    checked={task.task4Question3.includes('매물위치(주소)')}
                    onChange={changeTaskCheck}
                  />
                  <TextContent>매물위치(주소)</TextContent>
                </CheckLabel>
              </RadioRow>

              <RadioRow>
                <CheckLabel>
                  <Check
                    type="checkbox"
                    name="task4Question3"
                    value="기타"
                    checked={task.task4Question3.includes('기타')}
                    onChange={changeTaskCheck}
                  />
                  <TextContent>기타</TextContent>
                </CheckLabel>
              </RadioRow>

              {task.task4Question3.includes('기타') && (
                <InputWrap>
                  <Label>
                    <p>기타의견을 작성해 주세요.</p>
                    <Input
                      name="task4Question3Etc"
                      value={task.task4Question3Etc}
                      onChange={changeTaskInput}
                    />
                  </Label>
                </InputWrap>
              )}
            </QuestionWrap>

            <QuestionWrap>
              <p>Q. 매물 리스트내에서 제공하는 매물의 정보 중 가장 불필요하다고 생각하는 항목은 무엇인가요?<span>*</span></p>
              <p style={{ color: 'red', textDecoration: 'underline' }}>[다중선택 가능]</p>

              <RadioRow style={{ marginTop: 8 }}>
                <CheckLabel>
                  <Check
                    type="checkbox"
                    name="task4Question4"
                    value="사진"
                    checked={task.task4Question4.includes('사진')}
                    onChange={changeTaskCheck}
                  />
                  <TextContent>사진</TextContent>
                </CheckLabel>

                <CheckLabel>
                  <Check
                    type="checkbox"
                    name="task4Question4"
                    value="금액"
                    checked={task.task4Question4.includes('금액')}
                    onChange={changeTaskCheck}
                  />
                  <TextContent>금액</TextContent>
                </CheckLabel>

                <CheckLabel>
                  <Check
                    type="checkbox"
                    name="task4Question4"
                    value="층수"
                    checked={task.task4Question4.includes('층수')}
                    onChange={changeTaskCheck}
                  />
                  <TextContent>층수</TextContent>
                </CheckLabel>
              </RadioRow>

              <RadioRow>
                <CheckLabel>
                  <Check
                    type="checkbox"
                    name="task4Question4"
                    value="면적"
                    checked={task.task4Question4.includes('면적')}
                    onChange={changeTaskCheck}
                  />
                  <TextContent>면적</TextContent>
                </CheckLabel>

                <CheckLabel>
                  <Check
                    type="checkbox"
                    name="task4Question4"
                    value="관리비"
                    checked={task.task4Question4.includes('관리비')}
                    onChange={changeTaskCheck}
                  />
                  <TextContent>관리비</TextContent>
                </CheckLabel>

                <CheckLabel>
                  <Check
                    type="checkbox"
                    name="task4Question4"
                    value="주차여부"
                    checked={task.task4Question4.includes('주차여부')}
                    onChange={changeTaskCheck}
                  />
                  <TextContent>주차여부</TextContent>
                </CheckLabel>
              </RadioRow>

              <RadioRow>
                <CheckLabel>
                  <Check
                    type="checkbox"
                    name="task4Question4"
                    value="단기임대여부"
                    checked={task.task4Question4.includes('단기임대여부')}
                    onChange={changeTaskCheck}
                  />
                  <TextContent>단기임대여부</TextContent>
                </CheckLabel>

                <CheckLabel>
                  <Check
                    type="checkbox"
                    name="task4Question4"
                    value="입주가능일"
                    checked={task.task4Question4.includes('입주가능일')}
                    onChange={changeTaskCheck}
                  />
                  <TextContent>입주가능일</TextContent>
                </CheckLabel>

                <CheckLabel>
                  <Check
                    type="checkbox"
                    name="task4Question4"
                    value="매물설명"
                    checked={task.task4Question4.includes('매물설명')}
                    onChange={changeTaskCheck}
                  />
                  <TextContent>매물설명</TextContent>
                </CheckLabel>
              </RadioRow>

              <RadioRow>
                <CheckLabel>
                  <Check
                    type="checkbox"
                    name="task4Question4"
                    value="방수"
                    checked={task.task4Question4.includes('방수')}
                    onChange={changeTaskCheck}
                  />
                  <TextContent>방수</TextContent>
                </CheckLabel>

                <CheckLabel>
                  <Check
                    type="checkbox"
                    name="task4Question4"
                    value="욕실수"
                    checked={task.task4Question4.includes('욕실수')}
                    onChange={changeTaskCheck}
                  />
                  <TextContent>욕실수</TextContent>
                </CheckLabel>

                <CheckLabel>
                  <Check
                    type="checkbox"
                    name="task4Question4"
                    value="매물위치(주소)"
                    checked={task.task4Question4.includes('매물위치(주소)')}
                    onChange={changeTaskCheck}
                  />
                  <TextContent>매물위치(주소)</TextContent>
                </CheckLabel>
              </RadioRow>

              <RadioRow>
                <CheckLabel>
                  <Check
                    type="checkbox"
                    name="task4Question4"
                    value="기타"
                    checked={task.task4Question4.includes('기타')}
                    onChange={changeTaskCheck}
                  />
                  <TextContent>기타</TextContent>
                </CheckLabel>
              </RadioRow>

              {task.task4Question4.includes('기타') && (
                <InputWrap>
                  <Label>
                    <p>기타의견을 작성해 주세요.</p>
                    <Input
                      name="task4Question4Etc"
                      value={task.task4Question4Etc}
                      onChange={changeTaskInput}
                    />
                  </Label>
                </InputWrap>
              )}
            </QuestionWrap>

            <BtnWrap>
              <GrayButton
                style={{ width: 120 }}
                onClick={() => changeStep(3)}
              >
                이전
              </GrayButton>
    
              <BlueButton
                style={{ width: 120 }}
                onClick={() => changeStep(5)}
              >
                다음
              </BlueButton>
            </BtnWrap>
          </>
        ) : step === 5 ? (
          <>
            <h1 style={{ lineHeight: '32px' }}>TASK5. 다방앱을 실행하여 (서울대입구역) 검색한 후 노출되는</h1>
            <h1 style={{ lineHeight: '32px', marginBottom: 32 }}>매물리스트에서 가장 관심있는 매물의 상세페이지로 이동해 주세요. (홈화면에서 시작해주세요.)</h1>

            <QuestionWrap>
              <p>Q. 수행과정을 상세하게 작성해주세요.<span>*</span></p>
              <p>(어떤 메뉴로 진입 및 클릭했는지 최대한 자세하게)</p>

              <Textarea
                name="task5Question1"
                value={task.task5Question1}
                onChange={changeTaskInput}
              />
            </QuestionWrap>

             <QuestionWrap>
              <p>Q. 매물 리스트에서 해당 매물을 선택하신 이유가 무엇인가요?<span>*</span></p>
              <p style={{ color: 'red', textDecoration: 'underline' }}>[다중선택 가능]</p>

              <RadioRow style={{ marginTop: 8 }}>
                <CheckLabel>
                  <Check
                    type="checkbox"
                    name="task5Question2"
                    value="사진"
                    checked={task.task5Question2.includes('사진')}
                    onChange={changeTaskCheck}
                  />
                  <TextContent>사진</TextContent>
                </CheckLabel>

                <CheckLabel>
                  <Check
                    type="checkbox"
                    name="task5Question2"
                    value="금액"
                    checked={task.task5Question2.includes('금액')}
                    onChange={changeTaskCheck}
                  />
                  <TextContent>금액</TextContent>
                </CheckLabel>

                <CheckLabel>
                  <Check
                    type="checkbox"
                    name="task5Question2"
                    value="다방싸인매물"
                    checked={task.task5Question2.includes('다방싸인매물')}
                    onChange={changeTaskCheck}
                  />
                  <TextContent>다방싸인매물</TextContent>
                </CheckLabel>
              </RadioRow>

              <RadioRow>
                <CheckLabel>
                  <Check
                    type="checkbox"
                    name="task5Question2"
                    value="확인매물"
                    checked={task.task5Question2.includes('확인매물')}
                    onChange={changeTaskCheck}
                  />
                  <TextContent>확인매물</TextContent>
                </CheckLabel>

                <CheckLabel>
                  <Check
                    type="checkbox"
                    name="task5Question2"
                    value="플러스매물"
                    checked={task.task5Question2.includes('플러스매물')}
                    onChange={changeTaskCheck}
                  />
                  <TextContent>플러스매물</TextContent>
                </CheckLabel>

                <CheckLabel>
                  <Check
                    type="checkbox"
                    name="task5Question2"
                    value="간편문의 가능 매물"
                    checked={task.task5Question2.includes('간편문의 가능 매물')}
                    onChange={changeTaskCheck}
                  />
                  <TextContent>간편문의 가능 매물</TextContent>
                </CheckLabel>
              </RadioRow>

              <RadioRow>
                <CheckLabel>
                  <Check
                    type="checkbox"
                    name="task5Question2"
                    value="관리비"
                    checked={task.task5Question2.includes('관리비')}
                    onChange={changeTaskCheck}
                  />
                  <TextContent>관리비</TextContent>
                </CheckLabel>

                <CheckLabel>
                  <Check
                    type="checkbox"
                    name="task5Question2"
                    value="기타"
                    checked={task.task5Question2.includes('기타')}
                    onChange={changeTaskCheck}
                  />
                  <TextContent>기타</TextContent>
                </CheckLabel>
              </RadioRow>

              {task.task5Question2.includes('기타') && (
                <InputWrap>
                  <Label>
                    <p>기타의견을 작성해 주세요.</p>
                    <Input
                      name="task5Question2Etc"
                      value={task.task5Question2Etc}
                      onChange={changeTaskInput}
                    />
                  </Label>
                </InputWrap>
              )}
            </QuestionWrap>

             <QuestionWrap>
              <p>Q. 매물 상세페이지에서 제공하는 매물의 정보 중 가장 필요하다고 생각하는 항목은 무엇인가요?<span>*</span></p>
              <p style={{ color: 'red', textDecoration: 'underline' }}>[다중선택 가능]</p>

              <RadioRow style={{ marginTop: 8 }}>
                <CheckLabel>
                  <Check
                    type="checkbox"
                    name="task5Question3"
                    value="가격정보"
                    checked={task.task5Question3.includes('가격정보')}
                    onChange={changeTaskCheck}
                  />
                  <TextContent>가격정보</TextContent>
                </CheckLabel>

                <CheckLabel>
                  <Check
                    type="checkbox"
                    name="task5Question3"
                    value="상세정보"
                    checked={task.task5Question3.includes('상세정보')}
                    onChange={changeTaskCheck}
                  />
                  <TextContent>상세정보</TextContent>
                </CheckLabel>

                <CheckLabel>
                  <Check
                    type="checkbox"
                    name="task5Question3"
                    value="옵션"
                    checked={task.task5Question3.includes('옵션')}
                    onChange={changeTaskCheck}
                  />
                  <TextContent>옵션</TextContent>
                </CheckLabel>
              </RadioRow>

              <RadioRow>
                <CheckLabel>
                  <Check
                    type="checkbox"
                    name="task5Question3"
                    value="안전시설"
                    checked={task.task5Question3.includes('안전시설')}
                    onChange={changeTaskCheck}
                  />
                  <TextContent>보안/안전시설</TextContent>
                </CheckLabel>

                <CheckLabel>
                  <Check
                    type="checkbox"
                    name="task5Question3"
                    value="위치및주변시설"
                    checked={task.task5Question3.includes('위치및주변시설')}
                    onChange={changeTaskCheck}
                  />
                  <TextContent>위치및주변시설</TextContent>
                </CheckLabel>

                <CheckLabel>
                  <Check
                    type="checkbox"
                    name="task5Question3"
                    value="상세설명"
                    checked={task.task5Question3.includes('상세설명')}
                    onChange={changeTaskCheck}
                  />
                  <TextContent>상세설명</TextContent>
                </CheckLabel>
              </RadioRow>

              <RadioRow>
                <CheckLabel>
                  <Check
                    type="checkbox"
                    name="task5Question3"
                    value="중개사무소정보"
                    checked={task.task5Question3.includes('중개사무소정보')}
                    onChange={changeTaskCheck}
                  />
                  <TextContent>중개사무소정보</TextContent>
                </CheckLabel>

                <CheckLabel>
                  <Check
                    type="checkbox"
                    name="task5Question3"
                    value="기타"
                    checked={task.task5Question3.includes('기타')}
                    onChange={changeTaskCheck}
                  />
                  <TextContent>기타</TextContent>
                </CheckLabel>
              </RadioRow>

              {task.task5Question3.includes('기타') && (
                <InputWrap>
                  <Label>
                    <p>기타의견을 작성해 주세요.</p>
                    <Input
                      name="task5Question3Etc"
                      value={task.task5Question3Etc}
                      onChange={changeTaskInput}
                    />
                  </Label>
                </InputWrap>
              )}
            </QuestionWrap>

             <QuestionWrap>
              <p>Q. 매물 상세페이지에서 제공하는 매물의 정부 중 불필요하다고 생각하는 항목은 무엇인가요?<span>*</span></p>
              <p style={{ color: 'red', textDecoration: 'underline' }}>[다중선택 가능]</p>

              <RadioRow style={{ marginTop: 8 }}>
                <CheckLabel>
                  <Check
                    type="checkbox"
                    name="task5Question4"
                    value="가격정보"
                    checked={task.task5Question4.includes('가격정보')}
                    onChange={changeTaskCheck}
                  />
                  <TextContent>가격정보</TextContent>
                </CheckLabel>

                <CheckLabel>
                  <Check
                    type="checkbox"
                    name="task5Question4"
                    value="상세정보"
                    checked={task.task5Question4.includes('상세정보')}
                    onChange={changeTaskCheck}
                  />
                  <TextContent>상세정보</TextContent>
                </CheckLabel>

                <CheckLabel>
                  <Check
                    type="checkbox"
                    name="task5Question4"
                    value="옵션"
                    checked={task.task5Question4.includes('옵션')}
                    onChange={changeTaskCheck}
                  />
                  <TextContent>옵션</TextContent>
                </CheckLabel>
              </RadioRow>

              <RadioRow>
                <CheckLabel>
                  <Check
                    type="checkbox"
                    name="task5Question4"
                    value="보안/안전시설"
                    checked={task.task5Question4.includes('보안/안전시설')}
                    onChange={changeTaskCheck}
                  />
                  <TextContent>보안/안전시설</TextContent>
                </CheckLabel>

                <CheckLabel>
                  <Check
                    type="checkbox"
                    name="task5Question4"
                    value="위치및주변시설"
                    checked={task.task5Question4.includes('위치및주변시설')}
                    onChange={changeTaskCheck}
                  />
                  <TextContent>위치및주변시설</TextContent>
                </CheckLabel>

                <CheckLabel>
                  <Check
                    type="checkbox"
                    name="task5Question4"
                    value="상세설명"
                    checked={task.task5Question4.includes('상세설명')}
                    onChange={changeTaskCheck}
                  />
                  <TextContent>상세설명</TextContent>
                </CheckLabel>
              </RadioRow>

              <RadioRow>
                <CheckLabel>
                  <Check
                    type="checkbox"
                    name="task5Question4"
                    value="중개사무소정보"
                    checked={task.task5Question4.includes('중개사무소정보')}
                    onChange={changeTaskCheck}
                  />
                  <TextContent>중개사무소정보</TextContent>
                </CheckLabel>

                <CheckLabel>
                  <Check
                    type="checkbox"
                    name="task5Question4"
                    value="기타"
                    checked={task.task5Question4.includes('기타')}
                    onChange={changeTaskCheck}
                  />
                  <TextContent>기타</TextContent>
                </CheckLabel>
              </RadioRow>

              {task.task5Question4.includes('기타') && (
                <InputWrap>
                  <Label>
                    <p>기타의견을 작성해 주세요.</p>
                    <Input
                      name="task5Question4Etc"
                      value={task.task5Question4Etc}
                      onChange={changeTaskInput}
                    />
                  </Label>
                </InputWrap>
              )}
            </QuestionWrap>

             <QuestionWrap>
              <p>Q. 매물 상세페이지에서 제공하는 매물의 정보 중<br />계약여부를 결정하는데 가장 큰 역할을 하는 항목은 무엇인가요?<span>*</span></p>
              <p style={{ color: 'red', textDecoration: 'underline' }}>[다중선택 가능]</p>

              <RadioRow style={{ marginTop: 8 }}>
                <CheckLabel>
                  <Check
                    type="checkbox"
                    name="task5Question5"
                    value="가격정보"
                    checked={task.task5Question5.includes('가격정보')}
                    onChange={changeTaskCheck}
                  />
                  <TextContent>가격정보</TextContent>
                </CheckLabel>

                <CheckLabel>
                  <Check
                    type="checkbox"
                    name="task5Question5"
                    value="상세정보"
                    checked={task.task5Question5.includes('상세정보')}
                    onChange={changeTaskCheck}
                  />
                  <TextContent>상세정보</TextContent>
                </CheckLabel>

                <CheckLabel>
                  <Check
                    type="checkbox"
                    name="task5Question5"
                    value="옵션"
                    checked={task.task5Question5.includes('옵션')}
                    onChange={changeTaskCheck}
                  />
                  <TextContent>옵션</TextContent>
                </CheckLabel>
              </RadioRow>

              <RadioRow>
                <CheckLabel>
                  <Check
                    type="checkbox"
                    name="task5Question5"
                    value="보안/안전시설"
                    checked={task.task5Question5.includes('보안/안전시설')}
                    onChange={changeTaskCheck}
                  />
                  <TextContent>보안/안전시설</TextContent>
                </CheckLabel>

                <CheckLabel>
                  <Check
                    type="checkbox"
                    name="task5Question5"
                    value="위치및주변시설"
                    checked={task.task5Question5.includes('위치및주변시설')}
                    onChange={changeTaskCheck}
                  />
                  <TextContent>위치및주변시설</TextContent>
                </CheckLabel>

                <CheckLabel>
                  <Check
                    type="checkbox"
                    name="task5Question5"
                    value="상세설명"
                    checked={task.task5Question5.includes('상세설명')}
                    onChange={changeTaskCheck}
                  />
                  <TextContent>상세설명</TextContent>
                </CheckLabel>
              </RadioRow>

              <RadioRow>
                <CheckLabel>
                  <Check
                    type="checkbox"
                    name="task5Question5"
                    value="중개사무소정보"
                    checked={task.task5Question5.includes('중개사무소정보')}
                    onChange={changeTaskCheck}
                  />
                  <TextContent>중개사무소정보</TextContent>
                </CheckLabel>

                <CheckLabel>
                  <Check
                    type="checkbox"
                    name="task5Question5"
                    value="기타"
                    checked={task.task5Question5.includes('기타')}
                    onChange={changeTaskCheck}
                  />
                  <TextContent>기타</TextContent>
                </CheckLabel>
              </RadioRow>

              {task.task5Question5.includes('기타') && (
                <InputWrap>
                  <Label>
                    <p>기타의견을 작성해 주세요.</p>
                    <Input
                      name="task5Question5Etc"
                      value={task.task5Question5Etc}
                      onChange={changeTaskInput}
                    />
                  </Label>
                </InputWrap>
              )}
            </QuestionWrap>

            <QuestionWrap>
              <p>Q. 현재 매물 상세페이지에서 제공하는 정보를 제외하고<br />추가로 제공하였으면 하는 정보는 있으신가요?<span>*</span></p>

              <Textarea
                name="task5Question6"
                value={task.task5Question6}
                onChange={changeTaskInput}
              />
            </QuestionWrap>

            <QuestionWrap>
              <p>Q. 만약 해당 매물이 허위라면 허위매물신고를 하기 위한 기능을 쉽게 찾을수 있나요?<span>*</span></p>

              <RadioRow>
                <RadioLabel>
                  <Radio
                    type="radio"
                    name="task5Question7"
                    value="어렵다"
                    checked={task.task5Question7 === '어렵다'}
                    onChange={changeTaskInput}
                  />
                  어렵다
                </RadioLabel>
              </RadioRow>
              
              <RadioRow>
                <RadioLabel>
                  <Radio
                    type="radio"
                    name="task5Question7"
                    value="보통이다"
                    checked={task.task5Question7 === '보통이다'}
                    onChange={changeTaskInput}
                  />
                  보통이다
                </RadioLabel>
              </RadioRow>

              <RadioRow>
                <RadioLabel>
                  <Radio
                    type="radio"
                    name="task5Question7"
                    value="쉽다"
                    checked={task.task5Question7 === '쉽다'}
                    onChange={changeTaskInput}
                  />
                  쉽다
                </RadioLabel>
              </RadioRow>
            </QuestionWrap>

            <QuestionWrap>
              <p>Q. 허위매물신고기능을 찾기가 보통 또는 어려웠다면 왜 그렇게 생각하십니까?<span>*</span></p>

              <Textarea
                name="task5Question8"
                value={task.task5Question8}
                onChange={changeTaskInput}
              />
            </QuestionWrap>

            <BtnWrap>
              <GrayButton
                style={{ width: 120 }}
                onClick={() => changeStep(4)}
              >
                이전
              </GrayButton>
    
              <BlueButton
                style={{ width: 120 }}
                onClick={() => changeStep(6)}
              >
                다음
              </BlueButton>
            </BtnWrap>
          </>
        ) : step === 6 ? (
          <>
            <h1 style={{ lineHeight: '32px' }}>TASK6. 다방앱을 실행하여 매물번호 [31074013]를 조회하여 매물상세에서</h1>
            <h1 style={{ lineHeight: '32px' }}>간편문의/문자문의/전화문의 순서로 각 1회씩 진행해주세요.</h1>
            <h1 style={{ lineHeight: '32px', marginBottom: 32 }}>(해당 매물은 테스트용으로 생성해논 매물정보입니다.)</h1>

            <QuestionWrap>
              <p>Q. 제공되는 3가지 문의방식(간편문의/문자문의/전화문의)의 차이점이 구분되시나요?<span>*</span></p>

              <RadioRow>
                <RadioLabel>
                  <Radio
                    type="radio"
                    name="task6Question1"
                    value="구분된다"
                    checked={task.task6Question1 === '구분된다'}
                    onChange={changeTaskInput}
                  />
                  구분된다
                </RadioLabel>
              </RadioRow>

              <RadioRow>
                <RadioLabel>
                  <Radio
                    type="radio"
                    name="task6Question1"
                    value="잘모르겠다"
                    checked={task.task6Question1 === '잘모르겠다'}
                    onChange={changeTaskInput}
                  />
                  잘모르겠다
                </RadioLabel>
              </RadioRow>

              <RadioRow>
                <RadioLabel>
                  <Radio
                    type="radio"
                    name="task6Question1"
                    value="기타"
                    checked={task.task6Question1 === '기타'}
                    onChange={changeTaskInput}
                  />
                  기타
                </RadioLabel>
              </RadioRow>

              {task.task6Question1.includes('기타') && (
                <InputWrap>
                  <Label>
                    <p>기타의견을 작성해 주세요.</p>
                    <Input
                      name="task6Question1Etc"
                      value={task.task6Question1Etc}
                      onChange={changeTaskInput}
                    />
                  </Label>
                </InputWrap>
              )}
            </QuestionWrap>

            <QuestionWrap>
              <p>Q. 간편문의 이용시 불편하거나 개선했으면 하는 부분이 있을까요?<span>*</span></p>

              <Textarea
                name="task6Question2"
                value={task.task6Question2}
                onChange={changeTaskInput}
              />
            </QuestionWrap>

            <QuestionWrap>
              <p>Q. 문자문의 이용시 불편하거나 개선했으면 하는 부분이 있을까요?<span>*</span></p>

              <Textarea
                name="task6Question3"
                value={task.task6Question3}
                onChange={changeTaskInput}
              />
            </QuestionWrap>

            <QuestionWrap>
              <p>Q. 전화문의 이용시 불편하거나 개선했으면 하는 부분이 있을까요?<span>*</span></p>

              <Textarea
                name="task6Question4"
                value={task.task6Question4}
                onChange={changeTaskInput}
              />
            </QuestionWrap>

            <QuestionWrap>
              <p>Q. 전화하기/문자하기/간편문의 중 가장 선호하는 방식은 무엇인가요?<span>*</span></p>
              <p style={{ color: 'red', textDecoration: 'underline' }}>[다중선택 가능]</p>

              <RadioRow style={{ marginTop: 8 }}>
                <CheckLabel>
                  <Check
                    type="checkbox"
                    name="task6Question5"
                    value="전화문의"
                    checked={task.task6Question5.includes('전화문의')}
                    onChange={changeTaskCheck}
                  />
                  <TextContent>전화문의</TextContent>
                </CheckLabel>

                <CheckLabel>
                  <Check
                    type="checkbox"
                    name="task6Question5"
                    value="문자문의"
                    checked={task.task6Question5.includes('문자문의')}
                    onChange={changeTaskCheck}
                  />
                  <TextContent>문자문의</TextContent>
                </CheckLabel>

                <CheckLabel>
                  <Check
                    type="checkbox"
                    name="task6Question5"
                    value="간편문의"
                    checked={task.task6Question5.includes('간편문의')}
                    onChange={changeTaskCheck}
                  />
                  <TextContent>간편문의</TextContent>
                </CheckLabel>
              </RadioRow>
            </QuestionWrap>

            <QuestionWrap>
              <p>Q. 왜 해당 문의방식을 가장 선호하시나요?<span>*</span></p>

              <Textarea
                name="task6Question6"
                value={task.task6Question6}
                onChange={changeTaskInput}
              />
            </QuestionWrap>

            <QuestionWrap>
              <p>Q. 중개사에게 해당 매물에 대해 문의를 하는 이유는 무엇인가요?<span>*</span></p>
              <p style={{ color: 'red', textDecoration: 'underline' }}>[다중선택 가능]</p>

              <RadioRow style={{ marginTop: 8 }}>
                <CheckLabel>
                  <Check
                    type="checkbox"
                    name="task6Question7"
                    value="계약가능여부확인"
                    checked={task.task6Question7.includes('계약가능여부확인')}
                    onChange={changeTaskCheck}
                  />
                  <TextContent>계약가능여부확인</TextContent>
                </CheckLabel>

                <CheckLabel>
                  <Check
                    type="checkbox"
                    name="task6Question7"
                    value="추가정보확인"
                    checked={task.task6Question7.includes('추가정보확인')}
                    onChange={changeTaskCheck}
                  />
                  <TextContent>추가정보확인</TextContent>
                </CheckLabel>

                <CheckLabel>
                  <Check
                    type="checkbox"
                    name="task6Question7"
                    value="비슷한매물추천"
                    checked={task.task6Question7.includes('비슷한매물추천')}
                    onChange={changeTaskCheck}
                  />
                  <TextContent>비슷한매물추천</TextContent>
                </CheckLabel>
              </RadioRow>

              <RadioRow>
                <CheckLabel>
                  <Check
                    type="checkbox"
                    name="task6Question7"
                    value="가격 또는 입주일 협의"
                    checked={task.task6Question7.includes('가격 또는 입주일 협의')}
                    onChange={changeTaskCheck}
                  />
                  <TextContent>가격 또는 입주일 협의</TextContent>
                </CheckLabel>

                <CheckLabel>
                  <Check
                    type="checkbox"
                    name="task6Question7"
                    value="기타"
                    checked={task.task6Question7.includes('기타')}
                    onChange={changeTaskCheck}
                  />
                  <TextContent>기타</TextContent>
                </CheckLabel>
              </RadioRow>

              {task.task6Question7.includes('기타') && (
                <InputWrap>
                  <Label>
                    <p>기타의견을 작성해 주세요.</p>
                    <Input
                      name="task6Question7Etc"
                      value={task.task6Question7Etc}
                      onChange={changeTaskInput}
                    />
                  </Label>
                </InputWrap>
              )}
            </QuestionWrap>

            <BtnWrap>
              <GrayButton
                style={{ width: 120 }}
                onClick={() => changeStep(5)}
              >
                이전
              </GrayButton>
    
              <BlueButton
                style={{ width: 120 }}
                onClick={() => changeStep(7)}
              >
                다음
              </BlueButton>
            </BtnWrap>
          </>
        ) : step === 7 ? (
          <>
            <h1 style={{ lineHeight: '32px' }}>TASK7. 다방앱을 실행하여 원하는 지역의 매물을 선택하여</h1>
            <h1 style={{ lineHeight: '32px', marginBottom: 32 }}>찜한후 찜한방 메뉴로 이동해주세요. (홈화면에서 시작해주세요.)</h1>

            <QuestionWrap>
              <p>Q. 수행과정을 상세하게 작성해주세요.<span>*</span></p>
              <p>(어떤 메뉴로 진입 및 클릭했는지 최대한 자세하게)</p>

              <Textarea
                name="task7Question1"
                value={task.task7Question1}
                onChange={changeTaskInput}
              />
            </QuestionWrap>

            <QuestionWrap>
              <p>Q. 수행 과정이 쉬었습니까?<span>*</span></p>

              <RadioRow>
                <RadioLabel>
                  <Radio
                    type="radio"
                    name="task7Question2"
                    value="쉽다"
                    checked={task.task7Question2 === '쉽다'}
                    onChange={changeTaskInput}
                  />
                  쉽다
                </RadioLabel>

                <RadioLabel>
                  <Radio
                    type="radio"
                    name="task7Question2"
                    value="보통이다"
                    checked={task.task7Question2 === '보통이다'}
                    onChange={changeTaskInput}
                  />
                  보통이다
                </RadioLabel>

                <RadioLabel>
                  <Radio
                    type="radio"
                    name="task7Question2"
                    value="어렵다"
                    checked={task.task7Question2 === '어렵다'}
                    onChange={changeTaskInput}
                  />
                  어렵다
                </RadioLabel>
              </RadioRow>
            </QuestionWrap>

            <QuestionWrap>
              <p>Q. 수행과정이 보통이거나 어려웠다면 왜 그렇게 생각하십니까?<span>*</span></p>
              <Textarea
                name="task7Question3"
                value={task.task7Question3}
                onChange={changeTaskInput}
              />
            </QuestionWrap>

            <QuestionWrap>
              <p>Q. 찜하기 기능은 어떤 경우 사용하며 찜한 후 제공하였으면 하는 기능이나 기대효과가 있으신가요?<span>*</span></p>
              <Textarea
                name="task7Question4"
                value={task.task7Question4}
                onChange={changeTaskInput}
              />
            </QuestionWrap>

            <BtnWrap>
              <GrayButton
                style={{ width: 120 }}
                onClick={() => changeStep(6)}
              >
                이전
              </GrayButton>
    
              <BlueButton
                style={{ width: 120 }}
                onClick={() => changeStep(8)}
              >
                다음
              </BlueButton>
            </BtnWrap>
          </>
        ) : step === 8 ? (
          <>
            <h1 style={{ lineHeight: '32px' }}>TASK8. 위 Task 수행하면서 좋았던점이나 불편한점</h1>
            <h1 style={{ lineHeight: '32px', marginBottom: 32 }}>또는 개선하였으면 하는 부분이 있다면 자유롭게 기술해주세요.</h1>

            <QuestionWrap>
              <Textarea
                name="taskResultQuestion"
                value={task.taskResultQuestion}
                onChange={changeTaskInput}
              />
            </QuestionWrap>

            <BtnWrap>
              <GrayButton
                style={{ width: 120 }}
                onClick={() => changeStep(7)}
              >
                이전
              </GrayButton>
    
              <BlueButton
                style={{ width: 120 }}
                onClick={() => changeStep(9)}
              >
                다음
              </BlueButton>
            </BtnWrap>
          </>
        ) : step === 9 ? (
          <>
            <h1 style={{ lineHeight: '32px', marginBottom: 32 }}>추가 설문조사</h1>

            <QuestionWrap>
              <p>Q. 다방 서비스를 한번이라도 사용해본적이 있나요?<span>*</span></p>

              <RadioRow>
                <RadioLabel>
                  <Radio
                    type="radio"
                    name="useQuestion1"
                    value="네"
                    checked={task.useQuestion1 === '네'}
                    onChange={changeTaskInput}
                  />
                  네
                </RadioLabel>
              </RadioRow>
              
              <RadioRow>
                <RadioLabel>
                  <Radio
                    type="radio"
                    name="useQuestion1"
                    value="아니오"
                    checked={task.useQuestion1 === '아니오'}
                    onChange={clickAddSurvey}
                  />
                  아니오
                </RadioLabel>
              </RadioRow>
            </QuestionWrap>

            {task.useQuestion1 === '네' && (
              <>
                <QuestionWrap>
                  <p>Q. 한달 기준 다방을 몇번이나 접속하시나요?<span>*</span></p>
  
                  <RadioRow>
                    <RadioLabel>
                      <Radio
                        type="radio"
                        name="useQuestion2"
                        value="현재 사용암함"
                        checked={task.useQuestion2 === '현재 사용암함'}
                        onChange={changeTaskInput}
                      />
                      현재 사용암함
                    </RadioLabel>
                  </RadioRow>
  
                  <RadioRow>
                    <RadioLabel>
                      <Radio
                        type="radio"
                        name="useQuestion2"
                        value="1~5회"
                        checked={task.useQuestion2 === '1~5회'}
                        onChange={changeTaskInput}
                      />
                      1~5회
                    </RadioLabel>
                  </RadioRow>
  
                  <RadioRow>
                    <RadioLabel>
                      <Radio
                        type="radio"
                        name="useQuestion2"
                        value="5~10회"
                        checked={task.useQuestion2 === '5~10회'}
                        onChange={changeTaskInput}
                      />
                      5~10회
                    </RadioLabel>
                  </RadioRow>
  
                  <RadioRow>
                    <RadioLabel>
                      <Radio
                        type="radio"
                        name="useQuestion2"
                        value="11~20회"
                        checked={task.useQuestion2 === '11~20회'}
                        onChange={changeTaskInput}
                      />
                      11~20회
                    </RadioLabel>
                  </RadioRow>
  
                  <RadioRow>
                    <RadioLabel>
                      <Radio
                        type="radio"
                        name="useQuestion2"
                        value="21회~30회"
                        checked={task.useQuestion2 === '21회~30회'}
                        onChange={changeTaskInput}
                      />
                      21회~30회
                    </RadioLabel>
                  </RadioRow>
  
                  <RadioRow>
                    <RadioLabel>
                      <Radio
                        type="radio"
                        name="useQuestion2"
                        value="30회 이상"
                        checked={task.useQuestion2 === '30회 이상'}
                        onChange={changeTaskInput}
                      />
                      30회 이상
                    </RadioLabel>
                  </RadioRow>
                </QuestionWrap>
  
                <QuestionWrap>
                  <p>Q. 다방앱을 설치하게된 계기는 무엇인가요?<span>*</span></p>
                  <p style={{ color: 'red', textDecoration: 'underline' }}>[다중선택 가능]</p>
  
                  <RadioRow style={{ marginTop: 8 }}>
                    <CheckLabel>
                      <Check
                        type="checkbox"
                        name="useQuestion3"
                        value="광고"
                        checked={task.useQuestion3.includes('광고')}
                        onChange={changeTaskCheck}
                      />
                      <TextContent>광고</TextContent>
                    </CheckLabel>
  
                    <CheckLabel>
                      <Check
                        type="checkbox"
                        name="useQuestion3"
                        value="앱스토어순위"
                        checked={task.useQuestion3.includes('앱스토어순위')}
                        onChange={changeTaskCheck}
                      />
                      <TextContent>앱스토어순위</TextContent>
                    </CheckLabel>
  
                    <CheckLabel>
                      <Check
                        type="checkbox"
                        name="useQuestion3"
                        value="주위사람 추천"
                        checked={task.useQuestion3.includes('주위사람 추천')}
                        onChange={changeTaskCheck}
                      />
                      <TextContent>주위사람 추천</TextContent>
                    </CheckLabel>
                  </RadioRow>
  
                  <RadioRow>
                    <CheckLabel>
                      <Check
                        type="checkbox"
                        name="useQuestion3"
                        value="타사 서비스 이용경험"
                        checked={task.useQuestion3.includes('타사 서비스 이용경험')}
                        onChange={changeTaskCheck}
                      />
                      <TextContent>타사 서비스 이용경험</TextContent>
                    </CheckLabel>
  
                    <CheckLabel>
                      <Check
                        type="checkbox"
                        name="useQuestion3"
                        value="기타"
                        checked={task.useQuestion3.includes('기타')}
                        onChange={changeTaskCheck}
                      />
                      <TextContent>기타</TextContent>
                    </CheckLabel>
                  </RadioRow>
  
                  {task.useQuestion3.includes('기타') && (
                    <InputWrap>
                      <Label>
                        <p>기타의견을 작성해 주세요.</p>
                        <Input
                          name="useQuestion3Etc"
                          value={task.useQuestion3Etc}
                          onChange={changeTaskInput}
                        />
                      </Label>
                    </InputWrap>
                  )}
                </QuestionWrap>
  
                <QuestionWrap>
                  <p>Q. 다방 서비스의 장점이 무엇이라고 생각하나요?<span>*</span></p>
                  <p style={{ color: 'red', textDecoration: 'underline' }}>[다중선택 가능]</p>
  
                  <RadioRow style={{ marginTop: 8 }}>
                    <CheckLabel>
                      <Check
                        type="checkbox"
                        name="useQuestion4"
                        value="검색 편의"
                        checked={task.useQuestion4.includes('검색 편의')}
                        onChange={changeTaskCheck}
                      />
                      <TextContent>검색 편의</TextContent>
                    </CheckLabel>
  
                    <CheckLabel>
                      <Check
                        type="checkbox"
                        name="useQuestion4"
                        value="다양한 필터"
                        checked={task.useQuestion4.includes('다양한 필터')}
                        onChange={changeTaskCheck}
                      />
                      <TextContent>다양한 필터</TextContent>
                    </CheckLabel>
                  </RadioRow>
  
                  <RadioRow>
                    <CheckLabel>
                      <Check
                        type="checkbox"
                        name="useQuestion4"
                        value="지도 편의성"
                        checked={task.useQuestion4.includes('지도 편의성')}
                        onChange={changeTaskCheck}
                      />
                      <TextContent>지도 편의성</TextContent>
                    </CheckLabel>
  
                    <CheckLabel>
                      <Check
                        type="checkbox"
                        name="useQuestion4"
                        value="다양한 매물 및 정보"
                        checked={task.useQuestion4.includes('다양한 매물 및 정보')}
                        onChange={changeTaskCheck}
                      />
                      <TextContent>다양한 매물 및 정보</TextContent>
                    </CheckLabel>
  
                    <CheckLabel>
                      <Check
                        type="checkbox"
                        name="useQuestion4"
                        value="디자인(UI/UX)"
                        checked={task.useQuestion4.includes('디자인(UI/UX)')}
                        onChange={changeTaskCheck}
                      />
                      <TextContent>디자인(UI/UX)</TextContent>
                    </CheckLabel>
                  </RadioRow>
  
                  <RadioRow>
                    <CheckLabel>
                      <Check
                        type="checkbox"
                        name="useQuestion4"
                        value="부가기능(분양, 그리기기능, 시세, 안전, 매물비교하기)"
                        checked={task.useQuestion4.includes('부가기능(분양, 그리기기능, 시세, 안전, 매물비교하기)')}
                        onChange={changeTaskCheck}
                      />
                      <TextContent>부가기능(분양, 그리기기능, 시세, 안전, 매물비교하기)</TextContent>
                    </CheckLabel>
                  </RadioRow>
  
                  <RadioRow>
                    <CheckLabel>
                      <Check
                        type="checkbox"
                        name="useQuestion4"
                        value="홈화면 컨텐츠 및 매물추천"
                        checked={task.useQuestion4.includes('홈화면 컨텐츠 및 매물추천')}
                        onChange={changeTaskCheck}
                      />
                      <TextContent>홈화면 컨텐츠 및 매물추천</TextContent>
                    </CheckLabel>
                  </RadioRow>
  
                  <RadioRow>
                    <CheckLabel>
                      <Check
                        type="checkbox"
                        name="useQuestion4"
                        value="허위매물"
                        checked={task.useQuestion4.includes('허위매물')}
                        onChange={changeTaskCheck}
                      />
                      <TextContent>허위매물</TextContent>
                    </CheckLabel>
  
                    <CheckLabel>
                      <Check
                        type="checkbox"
                        name="useQuestion4"
                        value="기타"
                        checked={task.useQuestion4.includes('기타')}
                        onChange={changeTaskCheck}
                      />
                      <TextContent>기타</TextContent>
                    </CheckLabel>
                  </RadioRow>
  
                  {task.useQuestion4.includes('기타') && (
                    <InputWrap>
                      <Label>
                        <p>기타의견을 작성해 주세요.</p>
                        <Input
                          name="useQuestion4Etc"
                          value={task.useQuestion4Etc}
                          onChange={changeTaskInput}
                        />
                      </Label>
                    </InputWrap>
                  )}
                </QuestionWrap>
  
                <QuestionWrap>
                  <p>Q. 선택한 사유는?<span>*</span></p>
  
                  <Textarea
                    name="useQuestion4Reason"
                    value={task.useQuestion4Reason}
                    onChange={changeTaskInput}
                  />
                </QuestionWrap>
  
                <QuestionWrap>
                  <p>Q. 다방 서비스의 단점이 무엇이라고 생각하나요?<span>*</span></p>
                  <p style={{ color: 'red', textDecoration: 'underline' }}>[다중선택 가능]</p>
  
                  <RadioRow style={{ marginTop: 8 }}>
                    <CheckLabel>
                      <Check
                        type="checkbox"
                        name="useQuestion5"
                        value="검색 편의"
                        checked={task.useQuestion5.includes('검색 편의')}
                        onChange={changeTaskCheck}
                      />
                      <TextContent>검색 편의</TextContent>
                    </CheckLabel>
  
                    <CheckLabel>
                      <Check
                        type="checkbox"
                        name="useQuestion5"
                        value="다양한 필터"
                        checked={task.useQuestion5.includes('다양한 필터')}
                        onChange={changeTaskCheck}
                      />
                      <TextContent>다양한 필터</TextContent>
                    </CheckLabel>
                  </RadioRow>
  
                  <RadioRow>
                    <CheckLabel>
                      <Check
                        type="checkbox"
                        name="useQuestion5"
                        value="지도 편의성"
                        checked={task.useQuestion5.includes('지도 편의성')}
                        onChange={changeTaskCheck}
                      />
                      <TextContent>지도 편의성</TextContent>
                    </CheckLabel>
  
                    <CheckLabel>
                      <Check
                        type="checkbox"
                        name="useQuestion5"
                        value="다양한 매물 및 정보"
                        checked={task.useQuestion5.includes('다양한 매물 및 정보')}
                        onChange={changeTaskCheck}
                      />
                      <TextContent>다양한 매물 및 정보</TextContent>
                    </CheckLabel>
  
                    <CheckLabel>
                      <Check
                        type="checkbox"
                        name="useQuestion5"
                        value="디자인(UI/UX)"
                        checked={task.useQuestion5.includes('디자인(UI/UX)')}
                        onChange={changeTaskCheck}
                      />
                      <TextContent>디자인(UI/UX)</TextContent>
                    </CheckLabel>
                  </RadioRow>
  
                  <RadioRow>
                    <CheckLabel>
                      <Check
                        type="checkbox"
                        name="useQuestion5"
                        value="부가기능(분양, 그리기기능, 시세, 안전, 매물비교하기)"
                        checked={task.useQuestion5.includes('부가기능(분양, 그리기기능, 시세, 안전, 매물비교하기)')}
                        onChange={changeTaskCheck}
                      />
                      <TextContent>부가기능(분양, 그리기기능, 시세, 안전, 매물비교하기)</TextContent>
                    </CheckLabel>
                  </RadioRow>
  
                  <RadioRow>
                    <CheckLabel>
                      <Check
                        type="checkbox"
                        name="useQuestion5"
                        value="홈화면 컨텐츠 및 매물추천"
                        checked={task.useQuestion5.includes('홈화면 컨텐츠 및 매물추천')}
                        onChange={changeTaskCheck}
                      />
                      <TextContent>홈화면 컨텐츠 및 매물추천</TextContent>
                    </CheckLabel>
                  </RadioRow>
  
                  <RadioRow>
                    <CheckLabel>
                      <Check
                        type="checkbox"
                        name="useQuestion5"
                        value="허위매물"
                        checked={task.useQuestion5.includes('허위매물')}
                        onChange={changeTaskCheck}
                      />
                      <TextContent>허위매물</TextContent>
                    </CheckLabel>
  
                    <CheckLabel>
                      <Check
                        type="checkbox"
                        name="useQuestion5"
                        value="기타"
                        checked={task.useQuestion5.includes('기타')}
                        onChange={changeTaskCheck}
                      />
                      <TextContent>기타</TextContent>
                    </CheckLabel>
                  </RadioRow>
  
                  {task.useQuestion5.includes('기타') && (
                    <InputWrap>
                      <Label>
                        <p>기타의견을 작성해 주세요.</p>
                        <Input
                          name="useQuestion5Etc"
                          value={task.useQuestion5Etc}
                          onChange={changeTaskInput}
                        />
                      </Label>
                    </InputWrap>
                  )}
                </QuestionWrap>
  
                <QuestionWrap>
                  <p>Q. 선택한 사유는?<span>*</span></p>
  
                  <Textarea
                    name="useQuestion5Reason"
                    value={task.useQuestion5Reason}
                    onChange={changeTaskInput}
                  />
                </QuestionWrap>
  
                <QuestionWrap>
                  <p>Q. 다방 서비스내 허위매물 비율이 어느정도라고 생각하시나요?<span>*</span></p>
  
                  <RadioRow>
                    <RadioLabel>
                      <Radio
                        type="radio"
                        name="useQuestion6"
                        value="0~10%"
                        checked={task.useQuestion6 === '0~10%'}
                        onChange={changeTaskInput}
                      />
                      0~10%
                    </RadioLabel>
                  </RadioRow>
  
                  <RadioRow>
                    <RadioLabel>
                      <Radio
                        type="radio"
                        name="useQuestion6"
                        value="11~20%"
                        checked={task.useQuestion6 === '11~20%'}
                        onChange={changeTaskInput}
                      />
                      11~20%
                    </RadioLabel>
                  </RadioRow>
  
                  <RadioRow>
                    <RadioLabel>
                      <Radio
                        type="radio"
                        name="useQuestion6"
                        value="21~50%"
                        checked={task.useQuestion6 === '21~50%'}
                        onChange={changeTaskInput}
                      />
                      21~50%
                    </RadioLabel>
                  </RadioRow>
  
                  <RadioRow>
                    <RadioLabel>
                      <Radio
                        type="radio"
                        name="useQuestion6"
                        value="51~80%"
                        checked={task.useQuestion6 === '51~80%'}
                        onChange={changeTaskInput}
                      />
                      51~80%
                    </RadioLabel>
                  </RadioRow>
  
                  <RadioRow>
                    <RadioLabel>
                      <Radio
                        type="radio"
                        name="useQuestion6"
                        value="80%이상"
                        checked={task.useQuestion6 === '80%이상'}
                        onChange={changeTaskInput}
                      />
                      80%이상
                    </RadioLabel>
                  </RadioRow>
                </QuestionWrap>

                <QuestionWrap>
                  <p>Q. 선택한 사유는?<span>*</span></p>
  
                  <Textarea
                    name="useQuestion6Reason"
                    value={task.useQuestion6Reason}
                    onChange={changeTaskInput}
                  />
                </QuestionWrap>
  
                <QuestionWrap>
                  <p>Q. 필터중에 가장 사용성이 높다고 생각하는 항목이 있을까요?<span>*</span></p>
  
                  <RadioRow style={{ marginTop: 8 }}>
                    <CheckLabel>
                      <Check
                        type="checkbox"
                        name="useQuestion7"
                        value="방종류"
                        checked={task.useQuestion7.includes('방종류')}
                        onChange={changeTaskCheck}
                      />
                      <TextContent>방종류</TextContent>
                    </CheckLabel>
  
                    <CheckLabel>
                      <Check
                        type="checkbox"
                        name="useQuestion7"
                        value="거래유형"
                        checked={task.useQuestion7.includes('거래유형')}
                        onChange={changeTaskCheck}
                      />
                      <TextContent>거래유형</TextContent>
                    </CheckLabel>
  
                    <CheckLabel>
                      <Check
                        type="checkbox"
                        name="useQuestion7"
                        value="가격"
                        checked={task.useQuestion7.includes('가격')}
                        onChange={changeTaskCheck}
                      />
                      <TextContent>가격</TextContent>
                    </CheckLabel>
                  </RadioRow>
  
                  <RadioRow>
                    <CheckLabel>
                      <Check
                        type="checkbox"
                        name="useQuestion7"
                        value="관리비"
                        checked={task.useQuestion7.includes('관리비')}
                        onChange={changeTaskCheck}
                      />
                      <TextContent>관리비</TextContent>
                    </CheckLabel>
  
                    <CheckLabel>
                      <Check
                        type="checkbox"
                        name="useQuestion7"
                        value="방크기"
                        checked={task.useQuestion7.includes('방크기')}
                        onChange={changeTaskCheck}
                      />
                      <TextContent>방크기</TextContent>
                    </CheckLabel>
  
                    <CheckLabel>
                      <Check
                        type="checkbox"
                        name="useQuestion7"
                        value="사용승인일"
                        checked={task.useQuestion7.includes('사용승인일')}
                        onChange={changeTaskCheck}
                      />
                      <TextContent>사용승인일</TextContent>
                    </CheckLabel>
                  </RadioRow>
  
                  <RadioRow>
                    <CheckLabel>
                      <Check
                        type="checkbox"
                        name="useQuestion7"
                        value="추가필터(층수/방구조/거래종류/추가옵션)"
                        checked={task.useQuestion7.includes('추가필터(층수/방구조/거래종류/추가옵션)')}
                        onChange={changeTaskCheck}
                      />
                      <TextContent>추가필터(층수/방구조/거래종류/추가옵션)</TextContent>
                    </CheckLabel>
                  </RadioRow>
                </QuestionWrap>
  
                <QuestionWrap>
                  <p>Q. 선택한 사유는?<span>*</span></p>
  
                  <Textarea
                    name="useQuestion7Reason"
                    value={task.useQuestion7Reason}
                    onChange={changeTaskInput}
                  />
                </QuestionWrap>
  
                <QuestionWrap>
                  <p>Q. 필터중에 가장 불필요하다고 생각하는 항목이 있을까요?<span>*</span></p>
  
                  <RadioRow>
                    <CheckLabel>
                      <Check
                        type="checkbox"
                        name="useQuestion8"
                        value="방종류"
                        checked={task.useQuestion8.includes('방종류')}
                        onChange={changeTaskCheck}
                      />
                      <TextContent>방종류</TextContent>
                    </CheckLabel>
  
                    <CheckLabel>
                      <Check
                        type="checkbox"
                        name="useQuestion8"
                        value="거래유형"
                        checked={task.useQuestion8.includes('거래유형')}
                        onChange={changeTaskCheck}
                      />
                      <TextContent>거래유형</TextContent>
                    </CheckLabel>
  
                    <CheckLabel>
                      <Check
                        type="checkbox"
                        name="useQuestion8"
                        value="가격"
                        checked={task.useQuestion8.includes('가격')}
                        onChange={changeTaskCheck}
                      />
                      <TextContent>가격</TextContent>
                    </CheckLabel>
                  </RadioRow>
  
                  <RadioRow>
                    <CheckLabel>
                      <Check
                        type="checkbox"
                        name="useQuestion8"
                        value="관리비"
                        checked={task.useQuestion8.includes('관리비')}
                        onChange={changeTaskCheck}
                      />
                      <TextContent>관리비</TextContent>
                    </CheckLabel>
  
                    <CheckLabel>
                      <Check
                        type="checkbox"
                        name="useQuestion8"
                        value="방크기"
                        checked={task.useQuestion8.includes('방크기')}
                        onChange={changeTaskCheck}
                      />
                      <TextContent>방크기</TextContent>
                    </CheckLabel>
  
                    <CheckLabel>
                      <Check
                        type="checkbox"
                        name="useQuestion8"
                        value="사용승인일"
                        checked={task.useQuestion8.includes('사용승인일')}
                        onChange={changeTaskCheck}
                      />
                      <TextContent>사용승인일</TextContent>
                    </CheckLabel>
                  </RadioRow>
  
                  <RadioRow>
                    <CheckLabel>
                      <Check
                        type="checkbox"
                        name="useQuestion8"
                        value="추가필터(층수/방구조/거래종류/추가옵션)"
                        checked={task.useQuestion8.includes('추가필터(층수/방구조/거래종류/추가옵션)')}
                        onChange={changeTaskCheck}
                      />
                      <TextContent>추가필터(층수/방구조/거래종류/추가옵션)</TextContent>
                    </CheckLabel>
                  </RadioRow>
                </QuestionWrap>
  
                <QuestionWrap>
                  <p>Q. 선택한 사유는?<span>*</span></p>
  
                  <Textarea
                    name="useQuestion8Reason"
                    value={task.useQuestion8Reason}
                    onChange={changeTaskInput}
                  />
                </QuestionWrap>
  
                <QuestionWrap>
                  <p>Q. 필터 기능에서 추가로 있었으면 하는 필터 기능이 있을까요?<span>*</span></p>
  
                  <Textarea
                    name="useQuestion9"
                    value={task.useQuestion9}
                    onChange={changeTaskInput}
                  />
                </QuestionWrap>
  
                <QuestionWrap>
                  <p>Q. 부가기능중에 가장 필요하다고 생각하는 기능이 있을까요?<span>*</span></p>
  
                  <RadioRow style={{ marginTop: 8 }}>
                    <CheckLabel>
                      <Check
                        type="checkbox"
                        name="useQuestion10"
                        value="홈화면 추천매물(검색/찜기반)"
                        checked={task.useQuestion10.includes('홈화면 추천매물(검색/찜기반)')}
                        onChange={changeTaskCheck}
                      />
                      <TextContent>홈화면 추천매물(검색/찜기반)</TextContent>
                    </CheckLabel>
                  </RadioRow>
  
                  <RadioRow>
                    <CheckLabel>
                      <Check
                        type="checkbox"
                        name="useQuestion10"
                        value="분양"
                        checked={task.useQuestion10.includes('분양')}
                        onChange={changeTaskCheck}
                      />
                      <TextContent>분양</TextContent>
                    </CheckLabel>
  
                    <CheckLabel>
                      <Check
                        type="checkbox"
                        name="useQuestion10"
                        value="그리기기능"
                        checked={task.useQuestion10.includes('그리기기능')}
                        onChange={changeTaskCheck}
                      />
                      <TextContent>그리기기능</TextContent>
                    </CheckLabel>
  
                    <CheckLabel>
                      <Check
                        type="checkbox"
                        name="useQuestion10"
                        value="찜하기"
                        checked={task.useQuestion10.includes('찜하기')}
                        onChange={changeTaskCheck}
                      />
                      <TextContent>찜하기</TextContent>
                    </CheckLabel>
                  </RadioRow>
  
                  <RadioRow>
                    <CheckLabel>
                      <Check
                        type="checkbox"
                        name="useQuestion10"
                        value="시세"
                        checked={task.useQuestion10.includes('시세')}
                        onChange={changeTaskCheck}
                      />
                      <TextContent>시세</TextContent>
                    </CheckLabel>
  
                    <CheckLabel>
                      <Check
                        type="checkbox"
                        name="useQuestion10"
                        value="안전"
                        checked={task.useQuestion10.includes('안전')}
                        onChange={changeTaskCheck}
                      />
                      <TextContent>안전</TextContent>
                    </CheckLabel>
                  </RadioRow>
  
                  <RadioRow>
                    <CheckLabel>
                      <Check
                        type="checkbox"
                        name="useQuestion10"
                        value="쉬운방찾기"
                        checked={task.useQuestion10.includes('쉬운방찾기')}
                        onChange={changeTaskCheck}
                      />
                      <TextContent>쉬운방찾기</TextContent>
                    </CheckLabel>
  
                    <CheckLabel>
                      <Check
                        type="checkbox"
                        name="useQuestion10"
                        value="매물비교하기"
                        checked={task.useQuestion10.includes('매물비교하기')}
                        onChange={changeTaskCheck}
                      />
                      <TextContent>매물비교하기</TextContent>
                    </CheckLabel>
  
                    <CheckLabel>
                      <Check
                        type="checkbox"
                        name="useQuestion10"
                        value="기타"
                        checked={task.useQuestion10.includes('기타')}
                        onChange={changeTaskCheck}
                      />
                      <TextContent>기타</TextContent>
                    </CheckLabel>
                  </RadioRow>

                  {task.useQuestion10.includes('기타') && (
                    <InputWrap>
                      <Label>
                        <p>기타의견을 작성해 주세요.</p>
                        <Input
                          name="useQuestion10Etc"
                          value={task.useQuestion10Etc}
                          onChange={changeTaskInput}
                        />
                      </Label>
                    </InputWrap>
                  )}
                </QuestionWrap>
  
                <QuestionWrap>
                  <p>Q. 선택한 사유는?<span>*</span></p>
  
                  <Textarea
                    name="useQuestion10Reason"
                    value={task.useQuestion10Reason}
                    onChange={changeTaskInput}
                  />
                </QuestionWrap>
  
                <QuestionWrap>
                  <p>Q. 부가기능중에 가장 필요하다고 생각하는 기능이 있을까요?<span>*</span></p>
  
                  <RadioRow style={{ marginTop: 8 }}>
                    <CheckLabel>
                      <Check
                        type="checkbox"
                        name="useQuestion11"
                        value="홈화면 추천매물(검색/찜기반)"
                        checked={task.useQuestion11.includes('홈화면 추천매물(검색/찜기반)')}
                        onChange={changeTaskCheck}
                      />
                      <TextContent>홈화면 추천매물(검색/찜기반)</TextContent>
                    </CheckLabel>
                  </RadioRow>
  
                  <RadioRow>
                    <CheckLabel>
                      <Check
                        type="checkbox"
                        name="useQuestion11"
                        value="분양"
                        checked={task.useQuestion11.includes('분양')}
                        onChange={changeTaskCheck}
                      />
                      <TextContent>분양</TextContent>
                    </CheckLabel>
  
                    <CheckLabel>
                      <Check
                        type="checkbox"
                        name="useQuestion11"
                        value="그리기기능"
                        checked={task.useQuestion11.includes('그리기기능')}
                        onChange={changeTaskCheck}
                      />
                      <TextContent>그리기기능</TextContent>
                    </CheckLabel>
  
                    <CheckLabel>
                      <Check
                        type="checkbox"
                        name="useQuestion11"
                        value="찜하기"
                        checked={task.useQuestion11.includes('찜하기')}
                        onChange={changeTaskCheck}
                      />
                      <TextContent>찜하기</TextContent>
                    </CheckLabel>
                  </RadioRow>
  
                  <RadioRow>
                    <CheckLabel>
                      <Check
                        type="checkbox"
                        name="useQuestion11"
                        value="시세"
                        checked={task.useQuestion11.includes('시세')}
                        onChange={changeTaskCheck}
                      />
                      <TextContent>시세</TextContent>
                    </CheckLabel>
  
                    <CheckLabel>
                      <Check
                        type="checkbox"
                        name="useQuestion11"
                        value="안전"
                        checked={task.useQuestion11.includes('안전')}
                        onChange={changeTaskCheck}
                      />
                      <TextContent>안전</TextContent>
                    </CheckLabel>
                  </RadioRow>
  
                  <RadioRow>
                    <CheckLabel>
                      <Check
                        type="checkbox"
                        name="useQuestion11"
                        value="쉬운방찾기"
                        checked={task.useQuestion11.includes('쉬운방찾기')}
                        onChange={changeTaskCheck}
                      />
                      <TextContent>쉬운방찾기</TextContent>
                    </CheckLabel>
  
                    <CheckLabel>
                      <Check
                        type="checkbox"
                        name="useQuestion11"
                        value="매물비교하기"
                        checked={task.useQuestion11.includes('매물비교하기')}
                        onChange={changeTaskCheck}
                      />
                      <TextContent>매물비교하기</TextContent>
                    </CheckLabel>
  
                    <CheckLabel>
                      <Check
                        type="checkbox"
                        name="useQuestion11"
                        value="기타"
                        checked={task.useQuestion11.includes('기타')}
                        onChange={changeTaskCheck}
                      />
                      <TextContent>기타</TextContent>
                    </CheckLabel>
                  </RadioRow>

                  {task.useQuestion11.includes('기타') && (
                    <InputWrap>
                      <Label>
                        <p>기타의견을 작성해 주세요.</p>
                        <Input
                          name="useQuestion11Etc"
                          value={task.useQuestion11Etc}
                          onChange={changeTaskInput}
                        />
                      </Label>
                    </InputWrap>
                  )}
                </QuestionWrap>
  
                <QuestionWrap>
                  <p>Q. 선택한 사유는?<span>*</span></p>
  
                  <Textarea
                    name="useQuestion11Reason"
                    value={task.useQuestion11Reason}
                    onChange={changeTaskInput}
                  />
                </QuestionWrap>

                <BtnWrap>
                  <GrayButton
                    style={{ width: 120 }}
                    onClick={() => changeStep(8)}
                  >
                    이전
                  </GrayButton>
        
                  <BlueButton
                    style={{ width: 120 }}
                    onClick={() => changeStep(10)}
                  >
                    다음
                  </BlueButton>
                </BtnWrap>
              </>
            )}
          </>
        ) : step === 10 ? (
          <>
            <h1 style={{ lineHeight: '32px', marginBottom: 32 }}>타사 서비스 대비 사용성평가</h1>

            <QuestionWrap>
              <p>Q. 다방 서비스 이외 타사(직방, 네이버, 피터팬, 기타) 서비스를 이용해 보신 경험이 있으신가요?<span>*</span></p>

              <RadioRow>
                <RadioLabel>
                  <Radio
                    type="radio"
                    name="diffQuestion1"
                    value="네"
                    checked={task.diffQuestion1 === '네'}
                    onChange={changeTaskInput}
                  />
                  네
                </RadioLabel>
              </RadioRow>
              
              <RadioRow>
                <RadioLabel>
                  <Radio
                    type="radio"
                    name="diffQuestion1"
                    value="아니오"
                    checked={task.diffQuestion1 === '아니오'}
                    onChange={changeTaskInput}
                  />
                  아니오
                </RadioLabel>
              </RadioRow>
            </QuestionWrap>

            {task.diffQuestion1 === '네' && (
              <>
                <QuestionWrap>
                  <p>Q. 타사 서비스 대비 전체적인 디자인(UI/UX) 점수는?<span>*</span></p>
  
                  <RadioRow>
                    <RadioLabel>
                      <Radio
                        type="radio"
                        name="diffQuestion2"
                        value="5점"
                        checked={task.diffQuestion2 === '5점'}
                        onChange={changeTaskInput}
                      />
                      5점
                    </RadioLabel>
                  </RadioRow>
                  
                  <RadioRow>
                    <RadioLabel>
                      <Radio
                        type="radio"
                        name="diffQuestion2"
                        value="4점"
                        checked={task.diffQuestion2 === '4점'}
                        onChange={changeTaskInput}
                      />
                      4점
                    </RadioLabel>
                  </RadioRow>
  
                  <RadioRow>
                    <RadioLabel>
                      <Radio
                        type="radio"
                        name="diffQuestion2"
                        value="3점"
                        checked={task.diffQuestion2 === '3점'}
                        onChange={changeTaskInput}
                      />
                      3점
                    </RadioLabel>
                  </RadioRow>
                  
                  <RadioRow>
                    <RadioLabel>
                      <Radio
                        type="radio"
                        name="diffQuestion2"
                        value="2점"
                        checked={task.diffQuestion2 === '2점'}
                        onChange={changeTaskInput}
                      />
                      2점
                    </RadioLabel>
                  </RadioRow>
  
                  <RadioRow>
                    <RadioLabel>
                      <Radio
                        type="radio"
                        name="diffQuestion2"
                        value="1점"
                        checked={task.diffQuestion2 === '1점'}
                        onChange={changeTaskInput}
                      />
                      1점
                    </RadioLabel>
                  </RadioRow>
                </QuestionWrap>
  
                <QuestionWrap>
                  <p>Q. 선택한 사유는?<span>*</span></p>
  
                  <Textarea
                    name="diffQuestion2Reason"
                    value={task.diffQuestion2Reason}
                    onChange={changeTaskInput}
                  />
                </QuestionWrap>
  
                <QuestionWrap>
                  <p>Q. 타사 서비스 대비 홈화면 편의성 점수는?<span>*</span></p>
  
                  <RadioRow>
                    <RadioLabel>
                      <Radio
                        type="radio"
                        name="diffQuestion3"
                        value="5점"
                        checked={task.diffQuestion3 === '5점'}
                        onChange={changeTaskInput}
                      />
                      5점
                    </RadioLabel>
                  </RadioRow>
                  
                  <RadioRow>
                    <RadioLabel>
                      <Radio
                        type="radio"
                        name="diffQuestion3"
                        value="4점"
                        checked={task.diffQuestion3 === '4점'}
                        onChange={changeTaskInput}
                      />
                      4점
                    </RadioLabel>
                  </RadioRow>
  
                  <RadioRow>
                    <RadioLabel>
                      <Radio
                        type="radio"
                        name="diffQuestion3"
                        value="3점"
                        checked={task.diffQuestion3 === '3점'}
                        onChange={changeTaskInput}
                      />
                      3점
                    </RadioLabel>
                  </RadioRow>
                  
                  <RadioRow>
                    <RadioLabel>
                      <Radio
                        type="radio"
                        name="diffQuestion3"
                        value="2점"
                        checked={task.diffQuestion3 === '2점'}
                        onChange={changeTaskInput}
                      />
                      2점
                    </RadioLabel>
                  </RadioRow>
  
                  <RadioRow>
                    <RadioLabel>
                      <Radio
                        type="radio"
                        name="diffQuestion3"
                        value="1점"
                        checked={task.diffQuestion3 === '1점'}
                        onChange={changeTaskInput}
                      />
                      1점
                    </RadioLabel>
                  </RadioRow>
                </QuestionWrap>
  
                <QuestionWrap>
                  <p>Q. 선택한 사유는?<span>*</span></p>
  
                  <Textarea
                    name="diffQuestion3Reason"
                    value={task.diffQuestion3Reason}
                    onChange={changeTaskInput}
                  />
                </QuestionWrap>
  
                <QuestionWrap>
                  <p>Q. 타사 서비스 대비 지도화면 편의성 점수는?<span>*</span></p>
  
                  <RadioRow>
                    <RadioLabel>
                      <Radio
                        type="radio"
                        name="diffQuestion4"
                        value="5점"
                        checked={task.diffQuestion4 === '5점'}
                        onChange={changeTaskInput}
                      />
                      5점
                    </RadioLabel>
                  </RadioRow>
                  
                  <RadioRow>
                    <RadioLabel>
                      <Radio
                        type="radio"
                        name="diffQuestion4"
                        value="4점"
                        checked={task.diffQuestion4 === '4점'}
                        onChange={changeTaskInput}
                      />
                      4점
                    </RadioLabel>
                  </RadioRow>
  
                  <RadioRow>
                    <RadioLabel>
                      <Radio
                        type="radio"
                        name="diffQuestion4"
                        value="3점"
                        checked={task.diffQuestion4 === '3점'}
                        onChange={changeTaskInput}
                      />
                      3점
                    </RadioLabel>
                  </RadioRow>
                  
                  <RadioRow>
                    <RadioLabel>
                      <Radio
                        type="radio"
                        name="diffQuestion4"
                        value="2점"
                        checked={task.diffQuestion4 === '2점'}
                        onChange={changeTaskInput}
                      />
                      2점
                    </RadioLabel>
                  </RadioRow>
  
                  <RadioRow>
                    <RadioLabel>
                      <Radio
                        type="radio"
                        name="diffQuestion4"
                        value="1점"
                        checked={task.diffQuestion4 === '1점'}
                        onChange={changeTaskInput}
                      />
                      1점
                    </RadioLabel>
                  </RadioRow>
                </QuestionWrap>
  
                <QuestionWrap>
                  <p>Q. 선택한 사유는?<span>*</span></p>
  
                  <Textarea
                    name="diffQuestion4Reason"
                    value={task.diffQuestion4Reason}
                    onChange={changeTaskInput}
                  />
                </QuestionWrap>
  
                <QuestionWrap>
                  <p>Q. 타사 서비스 대비 매물리스트에서 제공하는 정보의 만족도 점수는?<span>*</span></p>
  
                  <RadioRow>
                    <RadioLabel>
                      <Radio
                        type="radio"
                        name="diffQuestion5"
                        value="5점"
                        checked={task.diffQuestion5 === '5점'}
                        onChange={changeTaskInput}
                      />
                      5점
                    </RadioLabel>
                  </RadioRow>
                  
                  <RadioRow>
                    <RadioLabel>
                      <Radio
                        type="radio"
                        name="diffQuestion5"
                        value="4점"
                        checked={task.diffQuestion5 === '4점'}
                        onChange={changeTaskInput}
                      />
                      4점
                    </RadioLabel>
                  </RadioRow>
  
                  <RadioRow>
                    <RadioLabel>
                      <Radio
                        type="radio"
                        name="diffQuestion5"
                        value="3점"
                        checked={task.diffQuestion5 === '3점'}
                        onChange={changeTaskInput}
                      />
                      3점
                    </RadioLabel>
                  </RadioRow>
                  
                  <RadioRow>
                    <RadioLabel>
                      <Radio
                        type="radio"
                        name="diffQuestion5"
                        value="2점"
                        checked={task.diffQuestion5 === '2점'}
                        onChange={changeTaskInput}
                      />
                      2점
                    </RadioLabel>
                  </RadioRow>
  
                  <RadioRow>
                    <RadioLabel>
                      <Radio
                        type="radio"
                        name="diffQuestion5"
                        value="1점"
                        checked={task.diffQuestion5 === '1점'}
                        onChange={changeTaskInput}
                      />
                      1점
                    </RadioLabel>
                  </RadioRow>
                </QuestionWrap>
  
                <QuestionWrap>
                  <p>Q. 선택한 사유는?<span>*</span></p>
  
                  <Textarea
                    name="diffQuestion5Reason"
                    value={task.diffQuestion5Reason}
                    onChange={changeTaskInput}
                  />
                </QuestionWrap>
  
                <QuestionWrap>
                  <p>Q. 타사 서비스 대비 매물상세에서 제공하는 정보의 만족도 점수는?<span>*</span></p>
  
                  <RadioRow>
                    <RadioLabel>
                      <Radio
                        type="radio"
                        name="diffQuestion6"
                        value="5점"
                        checked={task.diffQuestion6 === '5점'}
                        onChange={changeTaskInput}
                      />
                      5점
                    </RadioLabel>
                  </RadioRow>
                  
                  <RadioRow>
                    <RadioLabel>
                      <Radio
                        type="radio"
                        name="diffQuestion6"
                        value="4점"
                        checked={task.diffQuestion6 === '4점'}
                        onChange={changeTaskInput}
                      />
                      4점
                    </RadioLabel>
                  </RadioRow>
  
                  <RadioRow>
                    <RadioLabel>
                      <Radio
                        type="radio"
                        name="diffQuestion6"
                        value="3점"
                        checked={task.diffQuestion6 === '3점'}
                        onChange={changeTaskInput}
                      />
                      3점
                    </RadioLabel>
                  </RadioRow>
                  
                  <RadioRow>
                    <RadioLabel>
                      <Radio
                        type="radio"
                        name="diffQuestion6"
                        value="2점"
                        checked={task.diffQuestion6 === '2점'}
                        onChange={changeTaskInput}
                      />
                      2점
                    </RadioLabel>
                  </RadioRow>
  
                  <RadioRow>
                    <RadioLabel>
                      <Radio
                        type="radio"
                        name="diffQuestion6"
                        value="1점"
                        checked={task.diffQuestion6 === '1점'}
                        onChange={changeTaskInput}
                      />
                      1점
                    </RadioLabel>
                  </RadioRow>
                </QuestionWrap>
  
                <QuestionWrap>
                  <p>Q. 선택한 사유는?<span>*</span></p>
  
                  <Textarea
                    name="diffQuestion6Reason"
                    value={task.diffQuestion6Reason}
                    onChange={changeTaskInput}
                  />
                </QuestionWrap>
  
                <QuestionWrap>
                  <p>Q. 타사 서비스 대비 검색 편의성 점수는?<span>*</span></p>
  
                  <RadioRow>
                    <RadioLabel>
                      <Radio
                        type="radio"
                        name="diffQuestion7"
                        value="5점"
                        checked={task.diffQuestion7 === '5점'}
                        onChange={changeTaskInput}
                      />
                      5점
                    </RadioLabel>
                  </RadioRow>
                  
                  <RadioRow>
                    <RadioLabel>
                      <Radio
                        type="radio"
                        name="diffQuestion7"
                        value="4점"
                        checked={task.diffQuestion7 === '4점'}
                        onChange={changeTaskInput}
                      />
                      4점
                    </RadioLabel>
                  </RadioRow>
  
                  <RadioRow>
                    <RadioLabel>
                      <Radio
                        type="radio"
                        name="diffQuestion7"
                        value="3점"
                        checked={task.diffQuestion7 === '3점'}
                        onChange={changeTaskInput}
                      />
                      3점
                    </RadioLabel>
                  </RadioRow>
                  
                  <RadioRow>
                    <RadioLabel>
                      <Radio
                        type="radio"
                        name="diffQuestion7"
                        value="2점"
                        checked={task.diffQuestion7 === '2점'}
                        onChange={changeTaskInput}
                      />
                      2점
                    </RadioLabel>
                  </RadioRow>
  
                  <RadioRow>
                    <RadioLabel>
                      <Radio
                        type="radio"
                        name="diffQuestion7"
                        value="1점"
                        checked={task.diffQuestion7 === '1점'}
                        onChange={changeTaskInput}
                      />
                      1점
                    </RadioLabel>
                  </RadioRow>
                </QuestionWrap>
  
                <QuestionWrap>
                  <p>Q. 선택한 사유는?<span>*</span></p>
  
                  <Textarea
                    name="diffQuestion7Reason"
                    value={task.diffQuestion7Reason}
                    onChange={changeTaskInput}
                  />
                </QuestionWrap>
  
                <QuestionWrap>
                  <p>Q. 타사 서비스 대비 필터 편의성 점수는?<span>*</span></p>
  
                  <RadioRow>
                    <RadioLabel>
                      <Radio
                        type="radio"
                        name="diffQuestion8"
                        value="5점"
                        checked={task.diffQuestion8 === '5점'}
                        onChange={changeTaskInput}
                      />
                      5점
                    </RadioLabel>
                  </RadioRow>
                  
                  <RadioRow>
                    <RadioLabel>
                      <Radio
                        type="radio"
                        name="diffQuestion8"
                        value="4점"
                        checked={task.diffQuestion8 === '4점'}
                        onChange={changeTaskInput}
                      />
                      4점
                    </RadioLabel>
                  </RadioRow>
  
                  <RadioRow>
                    <RadioLabel>
                      <Radio
                        type="radio"
                        name="diffQuestion8"
                        value="3점"
                        checked={task.diffQuestion8 === '3점'}
                        onChange={changeTaskInput}
                      />
                      3점
                    </RadioLabel>
                  </RadioRow>
                  
                  <RadioRow>
                    <RadioLabel>
                      <Radio
                        type="radio"
                        name="diffQuestion8"
                        value="2점"
                        checked={task.diffQuestion8 === '2점'}
                        onChange={changeTaskInput}
                      />
                      2점
                    </RadioLabel>
                  </RadioRow>
  
                  <RadioRow>
                    <RadioLabel>
                      <Radio
                        type="radio"
                        name="diffQuestion8"
                        value="1점"
                        checked={task.diffQuestion8 === '1점'}
                        onChange={changeTaskInput}
                      />
                      1점
                    </RadioLabel>
                  </RadioRow>
                </QuestionWrap>
  
                <QuestionWrap>
                  <p>Q. 선택한 사유는?<span>*</span></p>
  
                  <Textarea
                    name="diffQuestion8Reason"
                    value={task.diffQuestion8Reason}
                    onChange={changeTaskInput}
                  />
                </QuestionWrap>
  
                <QuestionWrap>
                  <p>Q. 타사 서비스 대비 부가기능 제공 점수는?<span>*</span></p>
  
                  <RadioRow>
                    <RadioLabel>
                      <Radio
                        type="radio"
                        name="diffQuestion9"
                        value="5점"
                        checked={task.diffQuestion9 === '5점'}
                        onChange={changeTaskInput}
                      />
                      5점
                    </RadioLabel>
                  </RadioRow>
                  
                  <RadioRow>
                    <RadioLabel>
                      <Radio
                        type="radio"
                        name="diffQuestion9"
                        value="4점"
                        checked={task.diffQuestion9 === '4점'}
                        onChange={changeTaskInput}
                      />
                      4점
                    </RadioLabel>
                  </RadioRow>
  
                  <RadioRow>
                    <RadioLabel>
                      <Radio
                        type="radio"
                        name="diffQuestion9"
                        value="3점"
                        checked={task.diffQuestion9 === '3점'}
                        onChange={changeTaskInput}
                      />
                      3점
                    </RadioLabel>
                  </RadioRow>
                  
                  <RadioRow>
                    <RadioLabel>
                      <Radio
                        type="radio"
                        name="diffQuestion9"
                        value="2점"
                        checked={task.diffQuestion9 === '2점'}
                        onChange={changeTaskInput}
                      />
                      2점
                    </RadioLabel>
                  </RadioRow>
  
                  <RadioRow>
                    <RadioLabel>
                      <Radio
                        type="radio"
                        name="diffQuestion9"
                        value="1점"
                        checked={task.diffQuestion9 === '1점'}
                        onChange={changeTaskInput}
                      />
                      1점
                    </RadioLabel>
                  </RadioRow>
                </QuestionWrap>
  
                <QuestionWrap>
                  <p>Q. 선택한 사유는?<span>*</span></p>
  
                  <Textarea
                    name="diffQuestion9Reason"
                    value={task.diffQuestion9Reason}
                    onChange={changeTaskInput}
                  />
                </QuestionWrap>
  
                <QuestionWrap>
                  <p>Q. 타사 서비스 대비 허위매물 비율에 대한 점수는?<span>*</span></p>
  
                  <RadioRow>
                    <RadioLabel>
                      <Radio
                        type="radio"
                        name="diffQuestion10"
                        value="5점"
                        checked={task.diffQuestion10 === '5점'}
                        onChange={changeTaskInput}
                      />
                      5점
                    </RadioLabel>
                  </RadioRow>
                  
                  <RadioRow>
                    <RadioLabel>
                      <Radio
                        type="radio"
                        name="diffQuestion10"
                        value="4점"
                        checked={task.diffQuestion10 === '4점'}
                        onChange={changeTaskInput}
                      />
                      4점
                    </RadioLabel>
                  </RadioRow>
  
                  <RadioRow>
                    <RadioLabel>
                      <Radio
                        type="radio"
                        name="diffQuestion10"
                        value="3점"
                        checked={task.diffQuestion10 === '3점'}
                        onChange={changeTaskInput}
                      />
                      3점
                    </RadioLabel>
                  </RadioRow>
                  
                  <RadioRow>
                    <RadioLabel>
                      <Radio
                        type="radio"
                        name="diffQuestion10"
                        value="2점"
                        checked={task.diffQuestion10 === '2점'}
                        onChange={changeTaskInput}
                      />
                      2점
                    </RadioLabel>
                  </RadioRow>
  
                  <RadioRow>
                    <RadioLabel>
                      <Radio
                        type="radio"
                        name="diffQuestion10"
                        value="1점"
                        checked={task.diffQuestion10 === '1점'}
                        onChange={changeTaskInput}
                      />
                      1점
                    </RadioLabel>
                  </RadioRow>
                </QuestionWrap>
  
                <QuestionWrap>
                  <p>Q. 선택한 사유는?<span>*</span></p>
  
                  <Textarea
                    name="diffQuestion10Reason"
                    value={task.diffQuestion10Reason}
                    onChange={changeTaskInput}
                  />
                </QuestionWrap>
  
                <QuestionWrap>
                  <p>Q. 타사 서비스 대비 허위매물신고 또는 허위매물조치 대한 점수는?<span>*</span></p>
  
                  <RadioRow>
                    <RadioLabel>
                      <Radio
                        type="radio"
                        name="diffQuestion11"
                        value="5점"
                        checked={task.diffQuestion11 === '5점'}
                        onChange={changeTaskInput}
                      />
                      5점
                    </RadioLabel>
                  </RadioRow>
                  
                  <RadioRow>
                    <RadioLabel>
                      <Radio
                        type="radio"
                        name="diffQuestion11"
                        value="4점"
                        checked={task.diffQuestion11 === '4점'}
                        onChange={changeTaskInput}
                      />
                      4점
                    </RadioLabel>
                  </RadioRow>
  
                  <RadioRow>
                    <RadioLabel>
                      <Radio
                        type="radio"
                        name="diffQuestion11"
                        value="3점"
                        checked={task.diffQuestion11 === '3점'}
                        onChange={changeTaskInput}
                      />
                      3점
                    </RadioLabel>
                  </RadioRow>
                  
                  <RadioRow>
                    <RadioLabel>
                      <Radio
                        type="radio"
                        name="diffQuestion11"
                        value="2점"
                        checked={task.diffQuestion11 === '2점'}
                        onChange={changeTaskInput}
                      />
                      2점
                    </RadioLabel>
                  </RadioRow>
  
                  <RadioRow>
                    <RadioLabel>
                      <Radio
                        type="radio"
                        name="diffQuestion11"
                        value="1점"
                        checked={task.diffQuestion11 === '1점'}
                        onChange={changeTaskInput}
                      />
                      1점
                    </RadioLabel>
                  </RadioRow>
                </QuestionWrap>
  
                <QuestionWrap>
                  <p>Q. 선택한 사유는?<span>*</span></p>
  
                  <Textarea
                    name="diffQuestion11Reason"
                    value={task.diffQuestion11Reason}
                    onChange={changeTaskInput}
                  />
                </QuestionWrap>
              </>
            )}

            {task.diffQuestion1 && (
              <BtnWrap>
                <GrayButton
                  style={{ width: 120 }}
                  onClick={() => changeStep(9)}
                >
                  이전
                </GrayButton>
      
                <BlueButton
                  style={{ width: 120 }}
                  onClick={() => submit()}
                >
                  제출
                </BlueButton>
              </BtnWrap>
            )}
          </>
        ) : step === 'complete' ? (
          <>
            <CompleteImg
              src={CompleteGif}
              width="60"
              height="60"
              alt="매물 사진"
              draggable={false}
              loading="lazy"
            />

            <h1 style={{ textAlign: 'center' }}>{userInfo.userName}님 설문에 참여 해주셔서 감사합니다.</h1>
          </>
        ) : null}
      </div>
    </Wrap>
  );
}

export default DabangSurvey;
